import { JSX } from 'react';

/**
 * Icon definitions
 */
export const iconDefs = {
  /**
   * Blandade ikoner
   */
  account_card_details: (
    <path d="M23,5 L23,19 C23,20.1045695 22.1045695,21 21,21 L3,21 C1.8954305,21 1,20.1045695 1,19 L1,5 C1,3.8954305 1.8954305,3 3,3 L21,3 C22.1045695,3 23,3.8954305 23,5 Z M15,6 L15,7 L20,7 L20,6 L15,6 Z M15,8 L15,9 L19.6875,9 L20,9 L20,8 L15,8 Z M15,10 L15,11 L19,11 L19,10 L15,10 Z M9,13.91 C7,13.91 3,15 3,17 L3,18 L15,18 L15,17 C15,15 11,13.91 9,13.91 Z M9,6 C7.34314575,6 6,7.34314575 6,9 C6,10.6568542 7.34314575,12 9,12 C10.6568542,12 12,10.6568542 12,9 C12,7.34314575 10.6568542,6 9,6 Z" />
  ),
  accounting_record: (
    <g transform="translate(2.000000, 2.000000)">
      <path d="M18.5,7 L13,1.5 L13,7 L18.5,7 Z M14,0 L20,6 L20,18 C20,19.1045695 19.1045695,20 18,20 L2,20 C0.89,20 0,19.1 0,18 L0,2 C0,0.89 0.89,0 2,0 L14,0 Z M2,18 L18,18 L18,9 L11,9 L11,2 L2,2 L2,18 Z M5,17 L5,15 L3,15 L3,13 L5,13 L5,11 L7,11 L7,13 L9,13 L9,15 L7,15 L7,17 L5,17 Z M11,13 L17,13 L17,15 L11,15 L11,13 Z M4,4 L10,4 L10,5 L4,5 L4,4 Z M4,6 L10,6 L10,7 L4,7 L4,6 Z M4,8 L10,8 L10,9 L4,9 L4,8 Z" />
    </g>
  ),
  accounting_record_linked: (
    <g transform="translate(2.000000, 2.000000)">
      <path d="M18.5,7 L13,1.5 L13,7 L18.5,7 Z M14,0 L20,6 L20,18 C20,19.1045695 19.1045695,20 18,20 L2,20 C0.89,20 0,19.1 0,18 L0,2 C0,0.89 0.89,0 2,0 L14,0 Z M2,18 L18,18 L18,9 L11,9 L11,2 L2,2 L2,18 Z M4,4 L10,4 L10,5 L4,5 L4,4 Z M4,6 L10,6 L10,7 L4,7 L4,6 Z M4,8 L10,8 L10,9 L4,9 L4,8 Z M8,14 C8,12 9.33333333,11 12,11 C14.6666667,11 16,12 16,14 C16,16 14.6666667,17 12,17 C12,17 13,15.5 13,15.5 C14,15.5 14.5,15 14.5,14 C14.5,13 13.6666667,12.5 12,12.5 C10.3333333,12.5 9.5,13 9.5,14 L8,14 Z M12,14 C12,16 10.6666667,17 8,17 C5.33333333,17 4,16 4,14 C4,12 5.33333333,11 8,11 C8,11 7,12.5 7,12.5 C6,12.5 5.5,13 5.5,14 C5.5,15 6.33333333,15.5 8,15.5 C9.66666667,15.5 10.5,15 10.5,14 L12,14 Z" />
    </g>
  ),
  alternate_email: (
    <path d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 L17,22 L17,20 L12,20 C7.66,20 4,16.34 4,12 C4,7.66 7.66,4 12,4 C16.34,4 20,7.66 20,12 L20,13.43 C20,14.22 19.29,15 18.5,15 C17.71,15 17,14.22 17,13.43 L17,12 C17,9.24 14.76,7 12,7 C9.24,7 7,9.24 7,12 C7,14.76 9.24,17 12,17 C13.38,17 14.64,16.44 15.54,15.53 C16.19,16.42 17.31,17 18.5,17 C20.47,17 22,15.4 22,13.43 L22,12 C22,6.48 17.52,2 12,2 Z M12,15 C10.34,15 9,13.66 9,12 C9,10.34 10.34,9 12,9 C13.66,9 15,10.34 15,12 C15,13.66 13.66,15 12,15 Z" />
  ),
  assignment_message: (
    <g transform="translate(1.000000, 0.000000)">
      <path d="M21,12 L11,12 C9.8954305,12 9,12.8954305 9,14 L9,24 L11.5,22 L21,22 C22.1045695,22 23,21.1045695 23,20 L23,14 C23,12.8954305 22.1045695,12 21,12 Z" />
      <path d="M16,2 L11.82,2 C11.4,0.84 10.3,0 9,0 C7.7,0 6.6,0.84 6.18,2 L2,2 C0.9,2 0,2.9 0,4 L0,18 C0,19.1 0.9,20 2,20 L7,20 L7,13 C7,11.3431458 8.34314575,10 10,10 L18,10 L18,4 C18,2.9 17.1,2 16,2 Z M9,2 C9.55,2 10,2.45 10,3 C10,3.55 9.55,4 9,4 C8.45,4 8,3.55 8,3 C8,2.45 8.45,2 9,2 Z M6,16 L4,16 L4,14 L6,14 L6,16 Z M6,12 L4,12 L4,10 L6,10 L6,12 Z M14,8 L4,8 L4,6 L14,6 L14,8 Z" />
    </g>
  ),
  bar_chart: (
    <g>
      <path d="M0,0h24v24H0V0z" fill="none" />
      <path d="M10,20h4V4h-4V20z M16,20h4v-8h-4V20z M4,9v11h4V9H4z" />
    </g>
  ),
  chart_bar: (
    <path d="M3,9 L7,9 L7,19 L3,19 L3,9 Z M10,5 L14,5 L14,19 L10,19 L10,5 Z M17,13 L21,13 L21,19 L17,19 L17,13 Z" />
  ),
  chart_table: (
    <path d="M10,10.02 L15,10.02 L15,21 L10,21 L10,10.02 Z M17,21 L20,21 C21.1,21 22,20.1 22,19 L22,10 L17,10 L17,21 Z M20,3 L5,3 C3.9,3 3,3.9 3,5 L3,8 L22,8 L22,5 C22,3.9 21.1,3 20,3 Z M3,19 C3,20.1 3.9,21 5,21 L8,21 L8,10 L3,10 L3,19 Z" />
  ),
  coffin: (
    <path d="M16.2 23H7.8L5 8.862L7.8 1H16.2L19 8.862L16.2 23ZM8.871 2.666L6.592 8.976L8.871 21.476H15.012L17.286 8.976L15.012 2.666H8.871ZM14.225 20.527H9.585L7.568 8.96L9.425 3.613H14.418L16.194 8.96L14.225 20.527Z" />
  ),
  create_new_folder: (
    <path d="M20,6 L12,6 L10,4 L4,4 C2.89,4 2.01,4.89 2.01,6 L2,18 C2,19.11 2.89,20 4,20 L20,20 C21.11,20 22,19.11 22,18 L22,8 C22,6.89 21.11,6 20,6 Z M19,14 L16,14 L16,17 L14,17 L14,14 L11,14 L11,12 L14,12 L14,9 L16,9 L16,12 L19,12 L19,14 Z" />
  ),
  create_report: (
    <path
      fillRule="nonzero"
      d="M4,4 L20,4 C21.1045695,4 22,4.8954305 22,6 L22,18 C22,19.1045695 21.1045695,20 20,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,6 C2,4.8954305 2.8954305,4 4,4 Z M20,18 L20,6 L4,6 L4,18 L20,18 Z M13,11 L19,11 L19,13 L13,13 L13,11 Z M13,14 L19,14 L19,16 L13,16 L13,14 Z M13,8 L19,8 L19,10 L13,10 L13,8 Z M8,14 C6.34314575,14 5,12.6568542 5,11 C5,9.34314575 6.38221882,8 8,8 C8,8 8,9 8,11 C10,11 11,11 11,11 C11,12.6568542 9.65685425,14 8,14 Z"
    />
  ),
  cremation_plain: (
    <path d="M18 23H6L8 21H16L18 23ZM16 20H8C7.73842 18.6497 7.40461 17.3145 7 16L6.932 15.807V15.8C6.34882 14.2891 6.03343 12.6882 6 11.069C6.02455 9.65491 6.36629 8.26438 7 7H17C17.6436 8.22848 17.9863 9.59221 18 10.979C17.9639 12.6553 17.6395 14.3128 17.041 15.879L17 16C16.5955 17.3145 16.2616 18.6498 16 20ZM9 17V18H15V17H9ZM8 15V16H16V15H8ZM12 6H7C7.08013 5.29821 7.38332 4.64064 7.865 4.124C8.12203 3.79727 8.44497 3.52833 8.81282 3.33467C9.18067 3.14101 9.58517 3.02698 10 3H11V2C11 1.73478 11.1054 1.48043 11.2929 1.29289C11.4804 1.10536 11.7348 1 12 1C12.2652 1 12.5196 1.10536 12.7071 1.29289C12.8946 1.48043 13 1.73478 13 2V3H14C14.4175 3.02442 14.825 3.13736 15.1955 3.33132C15.566 3.52528 15.891 3.79582 16.149 4.125C16.625 4.64347 16.9232 5.30034 17 6H12Z" />
  ),
  cremation_act: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 16C7.40461 17.3145 7.73842 18.6497 8 20H16C16.2616 18.6498 16.5955 17.3145 17 16L17.041 15.879C17.6395 14.3128 17.9639 12.6553 18 10.979C17.9863 9.59221 17.6436 8.22848 17 7H7C6.36629 8.26438 6.02455 9.65491 6 11.069C6.03343 12.6882 6.34882 14.2891 6.932 15.8V15.807L7 16ZM8 21L6 23H18L16 21H8ZM9 18V17H15V18H9ZM7 6H12H17C16.9232 5.30034 16.625 4.64347 16.149 4.125C15.891 3.79582 15.566 3.52528 15.1955 3.33132C14.825 3.13736 14.4175 3.02442 14 3H13V2C13 1.73478 12.8946 1.48043 12.7071 1.29289C12.5196 1.10536 12.2652 1 12 1C11.7348 1 11.4804 1.10536 11.2929 1.29289C11.1054 1.48043 11 1.73478 11 2V3H10C9.58517 3.02698 9.18067 3.14102 8.81282 3.33467C8.44497 3.52833 8.12203 3.79727 7.865 4.124C7.38332 4.64064 7.08013 5.29821 7 6ZM11.081 11.4551C11.0082 11.6167 10.9398 11.7983 10.8772 12H13.1228C13.0602 11.7983 12.9918 11.6168 12.919 11.4552C12.5694 10.6782 12.1968 10.5 12 10.5C11.8032 10.5 11.4306 10.6781 11.081 11.4551ZM10.5 14.9999C10.5 14.2338 10.5544 13.5681 10.6472 13H13.3527C13.4456 13.5681 13.5 14.2339 13.5 15H14.5C14.5 13.291 14.2447 11.9643 13.831 11.0449C13.4306 10.1552 12.8032 9.50003 12 9.5C11.1968 9.49997 10.5694 10.1551 10.169 11.0448C9.75528 11.9642 9.5 13.2908 9.5 14.9999H10.5Z"
    />
  ),
  dashboard: (
    <path
      fillRule="nonzero"
      d="M3,13 L11,13 L11,3 L3,3 L3,13 Z M3,21 L11,21 L11,15 L3,15 L3,21 Z M13,21 L21,21 L21,11 L13,11 L13,21 Z M13,3 L13,9 L21,9 L21,3 L13,3 Z"
    />
  ),
  database: (
    <path
      fillRule="nonzero"
      d="M12,3 C7.58,3 4,4.79 4,7 C4,9.21 7.58,11 12,11 C16.42,11 20,9.21 20,7 C20,4.79 16.42,3 12,3 Z M4,9 L4,12 C4,14.21 7.58,16 12,16 C16.42,16 20,14.21 20,12 L20,9 C20,11.21 16.42,13 12,13 C7.58,13 4,11.21 4,9 Z M4,14 L4,17 C4,19.21 7.58,21 12,21 C16.42,21 20,19.21 20,17 L20,14 C20,16.21 16.42,18 12,18 C7.58,18 4,16.21 4,14 Z"
    />
  ),
  double_chevron_left: (
    <path d="M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z" />
  ),
  ekonomisk_analys: (
    <g transform="translate(2.000000, 2.000000)" fillRule="evenodd">
      <path d="M15,0 L19,0 L19,4 L17.5,2.5 L14,6 L11,3 L2,12 L2,18 L16,18 L18,20 L0,20 L0,0 L2,0 L2,10 L11,1 L14,4 L16.5,1.5 L15,0 Z M17.5777015,14.5471699 L21,17.9777017 L19.9770154,19.0006863 L16.5478559,15.5763294 L16.5478559,15.0329332 L16.3584906,14.8449401 C15.5783877,15.5132077 14.567753,15.9193826 13.4596913,15.9193826 C10.9965695,15.9193826 9,13.9228131 9,11.4596913 C9,8.99656949 10.9965695,7 13.4596913,7 C15.922813,7 17.9193825,8.99656949 17.9193825,11.4596913 C17.9193825,12.5677531 17.5125214,13.5790738 16.8435678,14.3591768 L17.0329331,14.5471699 L17.5777015,14.5471699 Z M13.4596913,14.5471699 C15.1646655,14.5471699 16.5471698,13.1653517 16.5471698,11.4596913 C16.5471698,9.75471702 15.1646655,8.37221271 13.4596913,8.37221271 C11.7540309,8.37221271 10.3722127,9.75471702 10.3722127,11.4596913 C10.3722127,13.1653517 11.7540309,14.5471699 13.4596913,14.5471699 Z" />
    </g>
  ),
  event_completed: (
    <g>
      <path d="M20 3H19V1H17V3H7V1H5V3H4C3.47005 3.00158 2.96227 3.2128 2.58753 3.58753C2.2128 3.96227 2.00158 4.47005 2 5V21C2.00158 21.5299 2.2128 22.0377 2.58753 22.4125C2.96227 22.7872 3.47005 22.9984 4 23H20C20.5299 22.9984 21.0377 22.7872 21.4125 22.4125C21.7872 22.0377 21.9984 21.5299 22 21V5C21.9984 4.47005 21.7872 3.96227 21.4125 3.58753C21.0377 3.2128 20.5299 3.00158 20 3V3ZM20 21H4V8H20V21Z" />
      <path d="M11.246 15.524C11.2302 15.104 11.2902 14.6847 11.423 14.286C11.5451 13.9791 11.7438 13.7085 12 13.5C12.2222 13.3198 12.4235 13.1151 12.6 12.89C12.7344 12.7151 12.8072 12.5006 12.807 12.28C12.807 11.7393 12.5737 11.469 12.107 11.469C12.0079 11.4658 11.9094 11.4855 11.8191 11.5264C11.7287 11.5673 11.649 11.6284 11.586 11.705C11.4447 11.8875 11.3708 12.1133 11.377 12.344H9.564C9.54993 12.0329 9.60312 11.7223 9.71995 11.4336C9.83679 11.1449 10.0145 10.8848 10.241 10.671C10.7667 10.2436 11.4338 10.0294 12.11 10.071C12.7748 10.0287 13.4328 10.2248 13.966 10.624C14.1885 10.8192 14.3635 11.0626 14.4775 11.3358C14.5916 11.6089 14.6417 11.9045 14.624 12.2C14.6278 12.4803 14.5672 12.7578 14.447 13.011C14.3017 13.2909 14.1092 13.5436 13.878 13.758L13.26 14.333C13.1017 14.4767 12.9771 14.6536 12.895 14.851C12.82 15.0678 12.7818 15.2956 12.782 15.525L11.246 15.524ZM11.026 17.157C11.022 17.033 11.0457 16.9097 11.0953 16.7961C11.145 16.6824 11.2193 16.5813 11.313 16.5C11.5112 16.3275 11.7674 16.2364 12.03 16.245C12.2926 16.2364 12.5488 16.3275 12.747 16.5C12.8402 16.5808 12.9142 16.6813 12.9638 16.7943C13.0135 16.9072 13.0374 17.0297 13.034 17.153C13.0374 17.2763 13.0135 17.3988 12.9638 17.5117C12.9142 17.6246 12.8402 17.7251 12.747 17.806C12.5493 17.9796 12.293 18.0718 12.03 18.064C11.7674 18.0726 11.5112 17.9815 11.313 17.809C11.2198 17.7283 11.1456 17.628 11.0958 17.5153C11.046 17.4026 11.0219 17.2802 11.025 17.157H11.026Z" />
    </g>
  ),
  event_ongoing: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.58789 22.4111C2.9624 22.7856 3.47038 22.9974 4 23H20C20.5298 22.9979 21.0375 22.7867 21.4121 22.4121C21.7867 22.0375 21.9979 21.5298 22 21V5C21.9976 4.4703 21.7867 3.96343 21.4121 3.58887C21.0375 3.21431 20.5297 3.00237 20 3H19V1H17V3H7V1H5V3H4C3.47038 3.00263 2.9624 3.21436 2.58789 3.58887C2.21339 3.96337 2.00263 4.47038 2 5V21C2.00263 21.5296 2.21339 22.0366 2.58789 22.4111ZM20 21H4V8H20V21ZM9.6 11L12 13.4L14.4 11L16 12.6L13.6 15L16 17.4L14.4 19L12 16.6L9.60001 19L8.00001 17.4L10.4 15L8 12.6L9.6 11Z"
    />
  ),
  excel_export: (
    <g transform="translate(2.000000, 2.000000)" fillRule="evenodd">
      <path d="M12,0 L0,2 L0,18 L12,20 L12,0 Z M13,2 L13,5 L15,5 L15,6 L13,6 L13,8 L15,8 L15,9 L13,9 L13,11 L15,11 L15,12 L13,12 L13,14 L15,14 L15,15 L13,15 L13,18 L18,18 C19.105469,18 20,17.105469 20,16 L20,4 C20,2.894531 19.105469,2 18,2 L13,2 Z M16,5 L18,5 L18,6 L16,6 L16,5 Z M2.21875,6 L4.28125,6 L5.34375,8.40625 C5.429688,8.601563 5.496094,8.804688 5.5625,9.0625 L5.59375,9.0625 C5.632813,8.910156 5.726563,8.683594 5.84375,8.375 L7.03125,6 L8.9375,6 L6.6875,9.96875 L9,14 L6.96875,14 L5.6875,11.40625 C5.636719,11.3125 5.578125,11.101563 5.53125,10.84375 L5.5,10.84375 C5.472656,10.964844 5.433594,11.160156 5.34375,11.40625 L4.03125,14 L2,14 L4.40625,10 L2.21875,6 Z M16,8 L18,8 L18,9 L16,9 L16,8 Z M16,11 L18,11 L18,12 L16,12 L16,11 Z M16,14 L18,14 L18,15 L16,15 L16,14 Z" />
    </g>
  ),
  expand_details: (
    <g fillRule="evenodd" transform="translate(2.000000, 2.000000)">
      <path d="M0,0 L0,2 L20,2 L20,0 L0,0 Z M0,4 L0,6 L20,6 L20,4 L0,4 Z M14.0006176,8 L14.0006176,10 L20,10 L20,8 L14.0006176,8 Z M3.42331865,15.5467383 L3.96803101,15.5467383 L4.15737687,15.3587559 C3.48849204,14.5786976 3.08167286,13.5674347 3.08167286,12.4594363 C3.08167286,9.99645532 5.07803682,8 7.54090507,8 C10.0037733,8 12.0001373,9.99645532 12.0001373,12.4594363 C12.0001373,14.9224172 10.0037733,16.9188726 7.54090507,16.9188726 C6.43295737,16.9188726 5.42242675,16.5127208 4.64240413,15.8444915 L4.45305827,16.0324738 L4.45305827,16.575839 L1.02425172,20 L0.0013724483,18.9770739 L3.42331865,15.5467383 Z M7.38860042,9.5 C5.68321313,9.5 4.30161619,10.8817392 4.30161619,12.587302 C4.30161619,14.2921788 5.68321313,15.6746041 7.38860042,15.6746041 C9.09330171,15.6746041 10.4755846,14.2921788 10.4755846,12.587302 C10.4755846,10.8817392 9.09330171,9.5 7.38860042,9.5 Z" />
    </g>
  ),
  eye_outline: (
    <g>
      <path d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
    </g>
  ),
  export: (
    <g>
      <path d="M12,1L8,5h3v9h2V5h3 M18,23H6c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h3v2H6v12h12V9h-3V7h3c1.1,0,2,0.9,2,2v12 C20,22.1,19.1,23,18,23z" />
    </g>
  ),
  export_failed: (
    <g>
      <path d="M15,9h3v6.6l2,2V9c0-1.1-0.9-2-2-2h-3V9z" />
      <path d="M11,8.6l2,2V5h3l-4-4L8,5h3V8.6z" />
      <path d="M3.1,3.5L1.7,4.9l2.8,2.8C4.2,8.1,4,8.5,4,9v11c0,1.1,0.9,2,2,2h12c0.2,0,0.5,0,0.7-0.1l1.4,1.4l1.4-1.4 L3.1,3.5z M6,20V9.2L16.8,20H6z" />
    </g>
  ),
  faktura_sida: (
    <g fillRule="evenodd">
      <polygon points="7 9 13 9 13 7 7 7" />
      <polygon points="7 13 13 13 13 11 7 11" />
      <polygon points="13 17 17 17 17 15 13 15" />
      <polygon points="15 9 17 9 17 7 15 7" />
      <polygon points="15 13 17 13 17 11 15 11" />
      <path d="M17,5 L17,3 L19,5 L17,5 Z M19,20 C19,20.5515 18.5515,21 18,21 L6,21 C5.4485,21 5,20.5515 5,20 L5,4 C5,3.4485 5.4485,3 6,3 L16,3 L16,5.5 C16,5.776 16.2235,6 16.5,6 L19,6 L19,20 Z M17.14,2 L15.86,2 L6,2 C4.8955,2 4,2.8955 4,4 L4,20 C4,21.1045 4.8955,22 6,22 L18,22 C19.1045,22 20,21.1045 20,20 L20,6.14 L20,4.86 L17.14,2 Z" />
    </g>
  ),
  file_percent: (
    <path
      fillRule="nonzero"
      d="M14,2 L20,8 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 L14,2 Z M7.37,20 L15,12.35 L13.65,11 L6,18.65 L7.37,20 Z M13,9 L18.5,9 L13,3.5 L13,9 Z M7.5,11 C6.67157288,11 6,11.6715729 6,12.5 C6,13.3284271 6.67157288,14 7.5,14 C8.32842712,14 9,13.3284271 9,12.5 C9,11.6715729 8.32842712,11 7.5,11 Z M13.5,17 C12.6715729,17 12,17.6715729 12,18.5 C12,19.3284271 12.6715729,20 13.5,20 C14.3284271,20 15,19.3284271 15,18.5 C15,17.6715729 14.3284271,17 13.5,17 Z"
    />
  ),
  filter_search: (
    <g transform="translate(3 6)">
      <path d="M14,2.05a3.5,3.5,0,1,0-.389,5.268L14,7.707v.707l3.535,3.536,1.415-1.415L15.414,7h-.707l-.389-.389A3.49,3.49,0,0,0,14,2.05m-.884,4.066a2.25,2.25,0,1,1,0-3.182,2.249,2.249,0,0,1,0,3.182" />
      <path d="M9.357,0H0V2H7.194A5,5,0,0,1,9.357,0" />
      <path d="M6.55,5H3V7H7.193A4.943,4.943,0,0,1,6.55,5" />
      <rect width="4" height="2" transform="translate(7 10)" />
      <path d="M13.643,0a5,5,0,0,1,2.163,2H18V0Z" />
    </g>
  ),
  filter_alt: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4.25006 5.61C6.27006 8.2 10.0001 13 10.0001 13V19C10.0001 19.55 10.4501 20 11.0001 20H13.0001C13.5501 20 14.0001 19.55 14.0001 19V13C14.0001 13 17.7201 8.2 19.7401 5.61C20.2501 4.95 19.7801 4 18.9501 4H5.04006C4.21006 4 3.74006 4.95 4.25006 5.61Z" />
      </svg>
    </g>
  ),
  functions: (
    <g>
      <path
        transform="translate(3.5 3.5)"
        d="M7.3396,3.4956 C7.3966,3.2931 7.4436,3.1311 7.4801,3.0096 C7.5171,2.8886 7.5771,2.7206 7.6596,2.5066 C7.7421,2.2926 7.8231,2.1166 7.9026,1.9776 C7.9826,1.8391 8.0911,1.6741 8.2271,1.4836 C8.3636,1.2926 8.5071,1.1336 8.6581,1.0061 C8.8086,0.8791 8.9931,0.7461 9.2126,0.6071 C9.4316,0.4686 9.6666,0.3586 9.9176,0.2776 C10.1671,0.1966 10.4576,0.1301 10.7871,0.0781 C11.1176,0.0261 11.4701,0.0001 11.8456,0.0001 L14.3311,0.0001 L13.5546,2.0001 L11.8881,2.0001 C10.5571,2.0001 9.7491,2.4001 9.4646,3.4001 L9.2856,4.0001 L12.7271,4.0001 L11.9771,6.0001 L8.7646,6.0001 L6.5461,13.7471 C6.3356,14.4991 6.0936,15.0686 5.8201,15.4561 C5.1036,16.4851 3.8631,17.0001 2.0996,17.0001 L0.0001,17.0001 L0.8706,15.0001 L2.0481,15.0001 C3.3911,15.0001 4.1846,14.6926 4.4291,13.8076 L6.6651,6.0001 L4.9771,6.0001 L5.7271,4.0001 L7.1856,4.0001 L7.3396,3.4956 Z"
      />
      <polygon
        transform="translate(11.5 11.5)"
        points="3.97 1.791 5.236 0 7.387 0 5.243 2.939 7.477 6 5.319 6 3.977 4.114 2.642 6 .477 6 2.711 2.939 .574 0 2.732 0"
      />
    </g>
  ),
  link_diagonal: (
    <path
      d="M3.9,12A3.1,3.1,0,0,1,7,8.9h4l-2-2L7,7A5,5,0,0,0,7,17l2,.1,2-2H7A3.1,3.1,0,0,1,3.9,12ZM8,13h8V11H8Zm9-6-2-.1-2,2h4a3.1,3.1,0,1,1,0,6.2H13l2,2,2-.1A5,5,0,0,0,17,7Z"
      transform="translate(-4.971 12) rotate(-45)"
    />
  ),
  lock_open_filled: (
    <path d="M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17Z" />
  ),
  logout: (
    <path
      d="M15,15.25 L15,12 L8,12 L8,8 L15,8 L15,4.75 L20.25,10 L15,15.25 Z M11,0 C12.1045695,0 13,0.8954305 13,2 L13,6 L11,6 L11,2 L2,2 L2,18 L11,18 L11,14 L13,14 L13,18 C13,19.1045695 12.1045695,20 11,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,2 C-2.22044605e-16,0.8954305 0.8954305,0 2,0 L11,0 Z"
      transform="translate(2 2)"
    />
  ),

  pin_off: (
    <path
      d="M0,3.27 L1.28,2 L18,18.72 L16.73,20 L10.8,14.07 L10.8,20 L9.2,20 L9.2,14 L4,14 L4,12 L6,10 L6,9.27 L0,3.27 Z M14,10 L16,12 L16,14 L15.82,14 L6,4.18 L6,2 L5,2 L5,0 L15,0 L15,2 L14,2 L14,10 Z"
      transform="translate(2 2)"
    />
  ),
  pin_on: (
    <polygon points="16 12 16 4 17 4 17 2 7 2 7 4 8 4 8 12 6 14 6 16 11.2 16 11.2 22 12.8 22 12.8 16 18 16 18 14" />
  ),
  process: (
    <path d="M9.50233061 6L9.50233061 7.5 12 5 9.50233061 2.5 9.50233061 4C5.50699184 4.591 2.5 7.9375 2.5 12 2.5 16.4775 6.00640919 19.9999 10.5011653 19.9999L10.5011653 18C7.00524388 18 4.5 15.5815 4.5 12 4.5 8.4185 6.50582654 6.5725 9.50233061 6zM20.698 10.4895L18.7915 10.198C18.6875 9.854 18.542 9.5105 18.365 9.177 18.719 8.6875 19.104 8.2295 19.4585 7.75 19.5105 7.677 19.5415 7.604 19.5415 7.5105 19.5415 7.427 19.521 7.344 19.469 7.281 19.0315 6.6665 18.3025 6.0205 17.75 5.5105 17.6775 5.448 17.5835 5.406 17.49 5.406 17.396 5.406 17.3025 5.4375 17.24 5.5L15.7605 6.6145C15.4585 6.4585 15.146 6.3335 14.823 6.2295L14.5315 4.3125C14.5105 4.1355 14.344 4 14.1565 4L13 4 13 9.333C14.469 9.333 15.6665 10.5315 15.6665 12 15.6665 13.4685 14.469 14.6665 13 14.6665L13 20 14.1565 20C14.344 20 14.49 19.8755 14.5315 19.7085 14.698 19.084 14.7605 18.406 14.8335 17.771 15.1565 17.6665 15.479 17.5315 15.7815 17.375L17.219 18.5005C17.3025 18.552 17.396 18.5935 17.49 18.5935 17.844 18.5935 19.25 17.063 19.5 16.729 19.5625 16.656 19.594 16.5835 19.594 16.49 19.594 16.396 19.5525 16.3025 19.49 16.2295 19.104 15.7605 18.729 15.3025 18.375 14.792 18.542 14.4895 18.667 14.1775 18.7815 13.844L20.7085 13.552C20.875 13.5215 21 13.3335 21 13.1775L21 10.8645C21 10.6875 20.875 10.5205 20.698 10.4895" />
  ),
  process_automatic_step: (
    <path d="M7,6 L17,6 C18.1045695,6 19,6.8954305 19,8 L19,16 C19,17.1045695 18.1045695,18 17,18 L7,18 C5.8954305,18 5,17.1045695 5,16 L5,8 C5,6.8954305 5.8954305,6 7,6 Z M7,10 L7,16 L17,16 L17,10 L7,10 Z M22,14 L23,14 C23,18.5 20,22 15.5,22 L15.5,24 L13,21.5 L15.552,19.026 L15.5,21 C19.5,21 22,18 22,14 Z M11,2.5 L8.5,5 L8.5,3 C4.5,3 2,6 2,10 L1,10 C1,5.5 4,2 8.5,2 L8.5,0 L11,2.5 Z" />
  ),
  process_manual_step: (
    <path d="M5,4 L19,4 C20.1045695,4 21,4.8954305 21,6 L21,18 C21,19.1045695 20.1045695,20 19,20 L5,20 C3.8954305,20 3,19.1045695 3,18 L3,6 C3,4.8954305 3.8954305,4 5,4 Z M5,8 L5,18 L19,18 L19,8 L5,8 Z" />
  ),
  process_external_inert: <rect x="1" y="4" width="22" height="16" rx="8" />,
  rotate_90_degrees_ccw: (
    <path d="M7.33999 6.41L0.859985 12.9L7.34999 19.38L13.84 12.9L7.33999 6.41ZM19.36 6.64C17.61 4.88 15.3 4 13 4V0.76L8.75999 5L13 9.24V6C14.79 6 16.58 6.68 17.95 8.05C20.68 10.78 20.68 15.22 17.95 17.95C16.58 19.32 14.79 20 13 20C12.03 20 11.06 19.79 10.16 19.39L8.66999 20.88C10.02 21.62 11.51 22 13 22C15.3 22 17.61 21.12 19.36 19.36C22.88 15.85 22.88 10.15 19.36 6.64Z" />
  ),
  rotate_image: (
    <path
      fillRule="evenodd"
      d="M9.77988 2.64426L6.94606 2.64445L6.94624 0.214733L9.77988 2.64426ZM2.83892 1.64287H6.94387V2.64287H2.83892C2.59659 2.64287 2.40015 2.83932 2.40015 3.08165V8.7143H1.40015V3.08165C1.40015 2.28703 2.04431 1.64287 2.83892 1.64287ZM5.58135 5.78573L18.3938 5.78573V18.2143H5.58135L5.58135 5.78573ZM19.3938 3.78573C19.9461 3.78573 20.3938 4.23345 20.3938 4.78573V19.2143C20.3938 19.7666 19.9461 20.2143 19.3938 20.2143H4.58135C4.02906 20.2143 3.58135 19.7666 3.58135 19.2143L3.58135 4.78573C3.58135 4.23345 4.02906 3.78573 4.58135 3.78573L19.3938 3.78573ZM17.3431 21.3476L14.5093 21.3478L17.343 23.7776L17.3431 22.3572H21.1504C21.945 22.3572 22.5892 21.713 22.5892 20.9184V15.2857H21.5892V20.9184C21.5892 21.1607 21.3927 21.3572 21.1504 21.3572H17.3431L17.3431 21.3476ZM13.6197 11.3001L17.0838 16.5501L12.2177 16.5501H7.02158L9.61966 12.8001L11.1615 15.0255L13.6197 11.3001Z"
    />
  ),
  rotate_90_degrees_cw: (
    <path d="M16.66 6.41L23.14 12.9L16.65 19.38L10.16 12.9L16.66 6.41ZM4.64 6.64C6.39 4.88 8.7 4 11 4V0.76L15.24 5L11 9.24V6C9.21 6 7.42 6.68 6.05 8.05C3.32 10.78 3.32 15.22 6.05 17.95C7.42 19.32 9.21 20 11 20C11.97 20 12.94 19.79 13.84 19.39L15.33 20.88C13.98 21.62 12.49 22 11 22C8.7 22 6.39 21.12 4.64 19.36C1.12 15.85 1.12 10.15 4.64 6.64Z" />
  ),
  repeated_event: (
    <path d="M10,20l4-4v3h6V17h2v4H14v3ZM9,20H2a2,2,0,0,1-2-2V4A2,2,0,0,1,2,2H3V0H5V2h9V0h2V2h1a2,2,0,0,1,2,2V7H17V6H2V18H9v2H9Zm11-7H14v2H12V11h8V8l4,4-4,4Z" />
  ),
  snowflake: (
    <path d="M22,11H17.83l3.24-3.24L19.66,6.34,15,11H13V9l4.66-4.66L16.24,2.93,13,6.17V2H11V6.17L7.76,2.93,6.34,4.34,11,9v2H9L4.34,6.34,2.93,7.76,6.17,11H2v2H6.17L2.93,16.24l1.41,1.42L9,13h2v2L6.34,19.66l1.42,1.41L11,17.83V22h2V17.83l3.24,3.24,1.42-1.41L13,15V13h2l4.66,4.66,1.41-1.42L17.83,13H22Z" />
  ),
  sort_alpha_asc: (
    <path d="M12.5,14 L12.5,9 L15,11.5 L12.5,14 Z M6.1,6.27 L1.6,17.73 L3.44,17.73 L4.36,15.28 L9.47,15.28 L10.39,17.73 L12.23,17.73 L7.74,6.27 L6.1,6.27 Z M4.97,13.64 L6.91,8.46 L8.85,13.64 L4.97,13.64 Z M16.73,16.14 L22.85,16.14 L22.85,17.73 L14.32,17.73 L14.32,16.44 L20.24,7.88 L14.36,7.88 L14.36,6.28 L22.66,6.28 L22.66,7.54 L16.73,16.14 Z" />
  ),
  sort_alpha_desc: (
    <path d="M10.5,14 L10.5,9 L13,11.5 L10.5,14 Z M17,6.27 L12.5,17.73 L14.34,17.73 L15.26,15.28 L20.37,15.28 L21.29,17.73 L23.13,17.73 L18.64,6.27 L17,6.27 Z M15.8100586,13.45 L17.7500586,8.27 L19.6900586,13.45 L15.8100586,13.45 Z M3.73,16.14 L9.85,16.14 L9.85,17.73 L1.32,17.73 L1.32,16.44 L7.24,7.88 L1.36,7.88 L1.36,6.28 L9.66,6.28 L9.66,7.54 L3.73,16.14 Z" />
  ),
  split_screen: (
    <g>
      <rect width="8" height="18" x="3" y="3" />
      <rect width="8" height="18" x="13" y="3" />
    </g>
  ),
  supplier_num: (
    <path d="M3,4 C1.8954305,4 1,4.8954305 1,6 L1,17 L3,17 C3,18.6568542 4.34314575,20 6,20 C7.65685425,20 9,18.6568542 9,17 L15,17 C15,18.6568542 16.3431458,20 18,20 C19.6568542,20 21,18.6568542 21,17 L23,17 L23,12 L20,8 L17,8 L17,4 L3,4 Z M17,9.5 L19.5,9.5 L21.47,12 L17,12 L17,9.5 Z M6,15.5 C6.82842712,15.5 7.5,16.1715729 7.5,17 C7.5,17.8284271 6.82842712,18.5 6,18.5 C5.17157288,18.5 4.5,17.8284271 4.5,17 C4.5,16.1715729 5.17157288,15.5 6,15.5 Z M18,15.5 C18.8284271,15.5 19.5,16.1715729 19.5,17 C19.5,17.8284271 18.8284271,18.5 18,18.5 C17.1715729,18.5 16.5,17.8284271 16.5,17 C16.5,16.1715729 17.1715729,15.5 18,15.5 Z M5.5,14 L4,14 L4,9 L3,9 L3,8 L4,7 L5.5,7 L5.5,14 Z M11,14 L7,14 L7,12 L9,10 L10,9 L9,8 L8,9 L7,9 L7,8 L8,7 L10,7 L11,8 L11,10 L8,13 L11,13 L11,14 Z M13,10 L14,10 L14.7734375,9.04589844 L14,8 L13,9 L12,9 L13,7 L15,7 L15.9916992,8 L15.9916992,9 L15,10.5 L16,12 L15.9916992,13 L15,14 L13,14 L12,12 L13,12 L14,13 L15,12 L14,11 L13,11 L13,10 Z" />
  ),
  table_column: (
    <path d="M8,2 L16,2 C17.1045695,2 18,2.8954305 18,4 L18,20 C18,21.1045695 17.1045695,22 16,22 L8,22 C6.8954305,22 6,21.1045695 6,20 L6,4 C6,2.8954305 6.8954305,2 8,2 Z M8,10 L8,14 L16,14 L16,10 L8,10 Z M8,16 L8,20 L16,20 L16,16 L8,16 Z M8,4 L8,8 L16,8 L16,4 L8,4 Z" />
  ),
  table_row: (
    <g transform="translate(3.000000, 3.000000)">
      <path
        d="M7,7.02 L19,7.02 L19,12.02 L7,12.02 L7,7.02 Z M7,19 L17,19 C18.1,19 19,18.1 19,17 L19,14 L7,14 L7,19 Z M17,0 L7,0 L7,5 L19,5 L19,2 C19,0.9 18.1,0 17,0 Z M0,17 C0,18.1 0.9,19 2,19 L5,19 L5,0 C3,0 2,1.17759968e-13 2,3.53279905e-13 C0.9,0 0,0.9 1.38777878e-16,2 C4.62592927e-17,2 0,7 0,17 Z"
        id="Shape"
      />
    </g>
  ),
  table_settings: (
    <g transform="translate(3.000000, 2.000000)" fillRule="evenodd">
      <path
        d="M4,18 L6,18 L6,20 L4,20 L4,18 Z M8,18 L10,18 L10,20 L8,20 L8,18 Z M12,18 L14,18 L14,20 L12,20 L12,18 Z M2,0 L16,0 C17.1045695,0 18,0.8954305 18,2 L18,14 C18,15.1045695 17.1045695,16 16,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,2 C0,0.8954305 0.8954305,0 2,0 Z M2,4 L2,8 L8,8 L8,4 L2,4 Z M10,4 L10,8 L16,8 L16,4 L10,4 Z M2,10 L2,14 L8,14 L8,10 L2,10 Z M10,10 L10,14 L16,14 L16,10 L10,10 Z"
        id="Shape"
      />
    </g>
  ),
  task_list: (
    <g transform="translate(3.000000, 7.000000)">
      <path d="M0,8 L2,8 L2,10 L0,10 L0,8 Z M0,4 L2,4 L2,6 L0,6 L0,4 Z M0,0 L2,0 L2,2 L0,2 L0,0 Z M4,8 L18,8 L18,10 L4,10 L4,8 Z M4,4 L14,4 L14,6 L4,6 L4,4 Z M4,0 L18,0 L18,2 L4,2 L4,0 Z" />
    </g>
  ),
  truck_delivery: (
    <path d="M3,4 C1.8954305,4 1,4.8954305 1,6 L1,17 L3,17 C3,18.6568542 4.34314575,20 6,20 C7.65685425,20 9,18.6568542 9,17 L15,17 C15,18.6568542 16.3431458,20 18,20 C19.6568542,20 21,18.6568542 21,17 L23,17 L23,12 L20,8 L17,8 L17,4 L3,4 Z M10,6 L14,10 L10,14 L10,11 L4,11 L4,9 L10,9 L10,6 Z M17,9.5 L19.5,9.5 L21.47,12 L17,12 L17,9.5 Z M6,15.5 C6.82842712,15.5 7.5,16.1715729 7.5,17 C7.5,17.8284271 6.82842712,18.5 6,18.5 C5.17157288,18.5 4.5,17.8284271 4.5,17 C4.5,16.1715729 5.17157288,15.5 6,15.5 Z M18,15.5 C18.8284271,15.5 19.5,16.1715729 19.5,17 C19.5,17.8284271 18.8284271,18.5 18,18.5 C17.1715729,18.5 16.5,17.8284271 16.5,17 C16.5,16.1715729 17.1715729,15.5 18,15.5 Z" />
  ),
  user_attribute: (
    <path d="M13,5 L22,5 L22,7 L13,7 L13,5 Z M13,9 L22,9 L22,11 L13,11 L13,9 Z M13,13 L22,13 L22,15 L13,15 L13,13 Z M7.5,13 C8.88,13 9.99,11.88 9.99,10.5 C9.99,9.12 8.88,8 7.5,8 C6.12,8 4.99,9.12 4.99,10.5 C4.99,11.88 6.12,13 7.5,13 Z M7.5,15 C5.67,15 2,15.92 2,17.75 L2,20 L13,20 L13,17.75 C13,15.92 9.33,15 7.5,15 Z" />
  ),
  vertical_split_screen: (
    <path
      d="M9.5,18V0h1V18Zm2-2V2H20V16ZM0,16V2H8.5V16Z"
      transform="translate(2 3)"
    />
  ),
  view_column: (
    <path d="M15,5 L15,19 L19,19 L19,5 L15,5 Z M5,19 L9,19 L9,5 L5,5 L5,19 Z M10,19 L14,19 L14,5 L10,5 L10,19 Z" />
  ),
  warning_round: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02943 21 3 16.9706 3 12C3 7.02943 7.02943 3 12 3C16.9706 3 21 7.02943 21 12ZM13 7V13H11V7H13ZM12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15Z"
    />
  ),
  zoom_reset: (
    <g transform="translate(3.000000, 3.000000)">
      <path d="M12.5,11 L11.71,11 L11.43,10.73 C12.41,9.59 13,8.11 13,6.5 C13,2.91 10.09,0 6.5,0 C2.91,0 0,2.91 0,6.5 C0,10.09 2.91,13 6.5,13 C8.11,13 9.59,12.41 10.73,11.43 L11,11.71 L11,12.5 L16,17.49 L17.49,16 L12.5,11 Z M6.5,11 C4.01,11 2,8.99 2,6.5 C2,4.01 4.01,2 6.5,2 C8.99,2 11,4.01 11,6.5 C11,8.99 8.99,11 6.5,11 Z M5,4.8 C5.34334013,4.5899932 5.57667347,4.42332653 5.7,4.3 C5.82332653,4.17667347 5.92332653,3.94334013 6,3.6 L7,3.6 L7,9 L6,9 L6,5 L5,5 L5,4.8 Z" />
    </g>
  ),
  x_stoft: (
    <g transform="scale(0.48)">
      <defs>
        <clipPath id="clip_xstoft">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip_xstoft)">
        <path d="M25 0C11.25 0 0 11.25 0 25C0 38.75 11.25 50 25 50C38.75 50 50 38.75 50 25C50 11.25 38.75 0 25 0ZM25 45C13.975 45 5 36.025 5 25C5 13.975 13.975 5 25 5C36.025 5 45 13.975 45 25C45 36.025 36.025 45 25 45Z" />
      </g>
    </g>
  ),
  stoft: (
    <g transform="scale(0.48)">
      <defs>
        <clipPath id="clip_stoft">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip_stoft)">
        <path d="M4.15048 24.8548C3.80263 25.0924 3.43235 25.1717 3.03964 25.0926C2.64721 25.0121 2.33476 24.7941 2.1023 24.4384C1.86984 24.0828 1.79229 23.7042 1.86967 23.3028C1.94841 22.9016 2.16171 22.5821 2.50956 22.3445C2.85742 22.1068 3.2277 22.0275 3.6204 22.1066C4.01283 22.1871 4.32528 22.4052 4.55775 22.7608C4.79021 23.1165 4.86775 23.495 4.79038 23.8965C4.71164 24.2977 4.49834 24.6171 4.15048 24.8548ZM21.1617 38.6525C19.8112 39.5752 18.3337 39.8735 16.7293 39.5473C15.1249 39.2211 13.8715 38.3677 12.9689 36.987L8.04618 29.4561C6.67875 27.3641 6.2326 25.0967 6.70774 22.6537C7.18288 20.2107 8.44356 18.2903 10.4898 16.8923L12.7304 15.3615C14.1422 14.3968 15.6673 14.0582 17.3055 14.3455C18.9443 14.6337 20.2286 15.489 21.1584 16.9115C21.7875 17.8738 22.1146 18.9286 22.1399 20.0758C22.1649 21.2244 21.8844 22.3014 21.2985 23.307C20.8489 24.0681 20.6365 24.8862 20.6615 25.7613C20.6862 26.6378 20.9379 27.4421 21.4165 28.1742L22.7907 30.2767C23.7069 31.6783 24.0072 33.1901 23.6918 34.8122C23.376 36.4358 22.5326 37.7158 21.1617 38.6525ZM5.57887 20.2475C5.23101 20.4851 4.86074 20.5644 4.46803 20.4853C4.0756 20.4048 3.76315 20.1867 3.53069 19.8311L3.12046 19.2035C2.88799 18.8479 2.81045 18.4693 2.88782 18.0678C2.96657 17.6666 3.17986 17.3472 3.52772 17.1095C3.87557 16.8719 4.24585 16.7926 4.63856 16.8717C5.03099 16.9522 5.34344 17.1703 5.5759 17.5259L5.98613 18.1535C6.2186 18.5091 6.29614 18.8877 6.21876 19.2892C6.14002 19.6904 5.92672 20.0098 5.57887 20.2475ZM19.5208 36.1422C20.196 35.6808 20.6137 35.0402 20.7739 34.2202C20.9327 33.3999 20.7865 32.6446 20.3353 31.9542L18.961 29.8518C18.1679 28.6385 17.7482 27.3063 17.7018 25.8551C17.6563 24.4034 18.0048 23.0456 18.7474 21.7816C19.0404 21.2789 19.1815 20.7358 19.1708 20.1524C19.1598 19.5704 18.997 19.0389 18.6825 18.5577C18.2039 17.8256 17.5446 17.4056 16.7046 17.298C15.8652 17.1912 15.0874 17.3825 14.3713 17.8718L12.1307 19.4026C10.7802 20.3253 9.94543 21.6068 9.6264 23.247C9.30738 24.8873 9.59912 26.3978 10.5016 27.7785L15.4244 35.3094C15.8756 35.9998 16.5027 36.4266 17.3056 36.5898C18.1071 36.7527 18.8455 36.6035 19.5208 36.1422ZM8.44158 16.4759C8.09372 16.7136 7.72358 16.7921 7.33115 16.7116C6.93844 16.6325 6.62586 16.4152 6.39339 16.0595L5.98316 15.4319C5.7507 15.0763 5.67357 14.6975 5.75176 14.2954C5.82968 13.8948 6.04257 13.5756 6.39043 13.338C6.73828 13.1003 7.10856 13.021 7.50126 13.1002C7.8937 13.1807 8.20615 13.3987 8.43861 13.7544L8.84884 14.3819C9.0813 14.7376 9.15857 15.1157 9.08065 15.5163C9.00246 15.9184 8.78943 16.2382 8.44158 16.4759ZM12.1247 13.9595C11.7769 14.1972 11.4067 14.2757 11.0143 14.1952C10.6216 14.1161 10.309 13.8988 10.0766 13.5431L9.2561 12.288C9.02364 11.9323 8.9465 11.5535 9.0247 11.1515C9.10262 10.7508 9.31551 10.4317 9.66336 10.194C10.0112 9.95635 10.3815 9.87707 10.7742 9.95617C11.1666 10.0367 11.4791 10.2547 11.7115 10.6104L12.532 11.8655C12.7645 12.2212 12.8417 12.5993 12.7638 12.9999C12.6856 13.402 12.4726 13.7218 12.1247 13.9595ZM17.2422 12.2789C16.7307 12.6284 16.1763 12.742 15.579 12.6199C14.9815 12.4992 14.5118 12.1773 14.17 11.6543L13.3495 10.3992C13.0076 9.87617 12.8964 9.30938 13.0159 8.69878C13.134 8.0879 13.4488 7.60771 13.9604 7.25821C14.4719 6.90871 15.0263 6.79503 15.6236 6.91717C16.2211 7.03791 16.6908 7.35977 17.0327 7.88276L17.8531 9.13792C18.195 9.66091 18.3062 10.2277 18.1867 10.8383C18.0686 11.4492 17.7538 11.9294 17.2422 12.2789Z" />
        <path d="M46.3525 25.4771C46.6872 25.7339 47.0527 25.8337 47.449 25.7766C47.8452 25.7181 48.1688 25.5178 48.4199 25.1757C48.671 24.8336 48.7687 24.4599 48.7128 24.0547C48.6556 23.6497 48.4597 23.3188 48.1251 23.0621C47.7904 22.8054 47.4249 22.7056 47.0286 22.7627C46.6324 22.8211 46.3088 23.0214 46.0577 23.3636C45.8066 23.7057 45.709 24.0794 45.7648 24.4846C45.822 24.8896 46.0179 25.2204 46.3525 25.4771ZM28.63 38.3049C29.9292 39.3016 31.3885 39.6818 33.0079 39.4457C34.6274 39.2096 35.9245 38.4274 36.8994 37.0991L42.217 29.8541C43.6941 27.8416 44.2606 25.6024 43.9166 23.1366C43.5726 20.6708 42.4164 18.6828 40.4479 17.1727L38.2924 15.5191C36.9341 14.4771 35.4294 14.0539 33.7783 14.2493C32.1266 14.4456 30.7985 15.228 29.7941 16.5965C29.1146 17.5222 28.7316 18.5572 28.6451 19.7012C28.5588 20.8467 28.7814 21.9379 29.3127 22.9746C29.7211 23.7597 29.8894 24.5885 29.8178 25.4608C29.7463 26.3346 29.4521 27.1236 28.9351 27.828L27.4506 29.8506C26.4609 31.199 26.0803 32.6918 26.3087 34.3291C26.5373 35.9678 27.3111 37.2931 28.63 38.3049ZM45.1723 20.797C45.507 21.0537 45.8724 21.1535 46.2688 21.0964C46.6649 21.038 46.9886 20.8376 47.2397 20.4955L47.6828 19.8918C47.9339 19.5496 48.0315 19.176 47.9757 18.7708C47.9185 18.3658 47.7226 18.0349 47.3879 17.7782C47.0533 17.5215 46.6878 17.4217 46.2915 17.4787C45.8953 17.5372 45.5717 17.7375 45.3206 18.0796L44.8775 18.6834C44.6264 19.0255 44.5287 19.3992 44.5845 19.8044C44.6417 20.2094 44.8377 20.5402 45.1723 20.797ZM30.4025 35.8899C29.7529 35.3915 29.37 34.7285 29.2538 33.9008C29.139 33.0729 29.3254 32.3269 29.8128 31.6627L31.2973 29.6402C32.154 28.4729 32.6442 27.1661 32.768 25.7197C32.891 24.2726 32.6155 22.8974 31.9415 21.5939C31.6758 21.0755 31.5639 20.5254 31.6057 19.9435C31.6478 19.363 31.8387 18.8413 32.1785 18.3784C32.6954 17.6741 33.3762 17.2916 34.2206 17.231C35.0645 17.1712 35.8309 17.4056 36.5199 17.9341L38.6754 19.5877C39.9746 20.5844 40.7397 21.9105 40.9706 23.5662C41.2016 25.2218 40.8296 26.7137 39.8548 28.042L34.5372 35.287C34.0498 35.9511 33.4008 36.3423 32.5904 36.4604C31.7814 36.5784 31.0521 36.3882 30.4025 35.8899ZM42.5153 16.8713C42.8499 17.128 43.2153 17.2271 43.6114 17.1686C44.0078 17.1115 44.3315 16.9119 44.5826 16.5698L45.0257 15.9661C45.2769 15.6239 45.3741 15.25 45.3175 14.8442C45.2611 14.4398 45.0655 14.1092 44.7309 13.8525C44.3963 13.5958 44.0308 13.4959 43.6344 13.553C43.2383 13.6115 42.9146 13.8118 42.6635 14.1539L42.2204 14.7577C41.9693 15.0998 41.872 15.4731 41.9284 15.8775C41.985 16.2833 42.1806 16.6145 42.5153 16.8713ZM38.9719 14.153C39.3066 14.4098 39.672 14.5089 40.0681 14.4504C40.4645 14.3933 40.7882 14.1937 41.0393 13.8516L41.9256 12.6441C42.1767 12.302 42.2739 11.928 42.2173 11.5222C42.1609 11.1178 41.9654 10.7873 41.6307 10.5305C41.2961 10.2738 40.9306 10.174 40.5342 10.2311C40.1381 10.2895 39.8145 10.4898 39.5634 10.832L38.6771 12.0395C38.426 12.3816 38.3286 12.7549 38.3851 13.1593C38.4417 13.5651 38.6373 13.8963 38.9719 14.153ZM33.9518 12.1893C34.444 12.5668 34.9915 12.7113 35.5943 12.6227C36.1974 12.5355 36.6836 12.2403 37.0529 11.7372L37.9391 10.5297C38.3084 10.0265 38.4497 9.46679 38.363 8.85043C38.2777 8.23387 37.989 7.73683 37.4969 7.3593C37.0047 6.98177 36.4572 6.83732 35.8543 6.92594C35.2513 7.01316 34.7651 7.30833 34.3958 7.81145L33.5096 9.01896C33.1403 9.52208 32.999 10.0818 33.0857 10.6982C33.171 11.3147 33.4597 11.8118 33.9518 12.1893Z" />
      </g>
    </g>
  ),
  kista: (
    <g transform="scale(0.48)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75191 30.5954L0.836123 27.8311C-0.155015 26.4009 -0.273896 24.5408 0.52714 22.9963L10.013 6.53641C10.8212 4.97823 12.4314 4 14.1882 4H35C36.5994 4 38.0892 4.81212 38.9546 6.15578L49.2522 22.8694C50.2805 24.466 50.2457 26.5239 49.1639 28.0848L47.424 30.5954L40.2498 43.2891C39.4772 44.9429 37.8156 46 35.9886 46H13.7642C11.9372 46 10.2756 44.9429 9.50302 43.2891L2.75191 30.5954ZM46.2642 26.0795L45.5761 27.0724H4.59975L3.73578 25.8257C3.488 25.4682 3.45828 25.0031 3.65854 24.617L13.1444 8.15713C13.3464 7.76758 13.749 7.52303 14.1882 7.52303H35C35.3999 7.52303 35.7723 7.72606 35.9886 8.06197L46.2863 24.7756C46.5434 25.1748 46.5347 25.6892 46.2642 26.0795ZM43.5321 30.5954H6.64377L12.6989 41.7992C12.892 42.2127 13.3074 42.477 13.7642 42.477H35.9886C36.4454 42.477 36.8608 42.2127 37.0539 41.7992L43.5321 30.5954Z"
      />
    </g>
  ),
  tom_urna: (
    <g transform="scale(0.48)">
      <defs>
        <clipPath id="clip_tom_urna">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip_tom_urna)">
        <path d="M26.5483 45.6367C26.9935 45.6367 27.3855 45.9308 27.5093 46.3584L28.2495 48.918C28.4325 49.5503 27.9585 50.1814 27.3003 50.1816L8.28662 50.1826C7.67609 50.1826 7.23142 49.6037 7.38818 49.0137L8.08935 46.3799C8.20589 45.9419 8.602 45.6368 9.05517 45.6367H26.5483ZM43.5786 45.1816C43.9005 45.1816 44.2032 45.3373 44.3911 45.5986L46.2212 48.1436C46.6968 48.8051 46.2235 49.7275 45.4087 49.7275H34.7817C34.0013 49.7275 33.5219 48.8734 33.9282 48.207L35.481 45.6611C35.6625 45.3636 35.9859 45.1817 36.3345 45.1816H43.5786ZM25.5181 7C25.9007 7 26.2479 7.21475 26.4097 7.56152C27.2096 9.2766 29.5832 14.5647 30.311 18.4287C31.9128 26.9326 27.6498 39.7183 26.5835 42.7178C26.4444 43.1092 26.0741 43.3633 25.6587 43.3633H9.78467C9.38883 43.3632 9.03338 43.137 8.88135 42.7715C7.67791 39.8768 2.63967 27.0136 4.35107 18.4287C5.13461 14.4985 7.78695 9.19054 8.65283 7.52344C8.82194 7.19784 9.15703 7 9.52392 7H25.5181ZM11.938 10.5986C11.5636 10.5988 11.2221 10.807 11.0581 11.1436C10.4303 12.4328 8.88504 15.764 8.31396 18.4287C6.74372 25.7558 10.1621 36.5593 11.0991 39.3027C11.2344 39.6989 11.6063 39.954 12.0249 39.9541H23.1704C23.6114 39.9541 23.9976 39.6729 24.1157 39.248C24.8999 36.4219 27.6354 25.7357 26.3491 18.4287C25.8947 15.8477 24.6838 12.5689 24.1606 11.2207C24.0139 10.8427 23.6491 10.5986 23.2437 10.5986H11.938Z" />
      </g>
    </g>
  ),
  urna_aska: (
    <g transform="scale(0.48)">
      <defs>
        <clipPath id="clip_urna_aska">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip_urna_aska)">
        <path d="M34.5483 45.4541C34.9933 45.4543 35.3845 45.7492 35.5083 46.1768L36.2495 48.7363C36.4324 49.3687 35.9576 50 35.2993 50H16.2866C15.6759 50 15.2311 49.4212 15.3881 48.8311L16.0883 46.1973C16.2049 45.7593 16.6019 45.4541 17.0551 45.4541H34.5483ZM33.518 6.81836C33.9006 6.81845 34.2479 7.03316 34.4096 7.37988C35.2098 9.09536 37.5832 14.3833 38.311 18.2471C39.9126 26.7511 35.6497 39.537 34.5834 42.5361C34.4444 42.9274 34.0739 43.1815 33.6586 43.1816H17.7846C17.3886 43.1816 17.0333 42.9545 16.8813 42.5889C15.6777 39.6938 10.6398 26.8318 12.351 18.2471C13.1346 14.3168 15.786 9.00787 16.6518 7.34082C16.821 7.01536 17.1571 6.81836 17.5239 6.81836H33.518ZM19.9379 10.417C19.5634 10.417 19.2211 10.6251 19.0571 10.9619C18.4292 12.2514 16.884 15.5826 16.3129 18.2471C14.7429 25.5743 18.1622 36.3781 19.0991 39.1211C19.2345 39.5173 19.6062 39.7725 20.0249 39.7725H31.1704C31.6115 39.7725 31.9977 39.4906 32.1157 39.0654C32.8999 36.239 35.6343 25.5539 34.3481 18.2471C33.8937 15.6659 32.6827 12.386 32.1596 11.0381C32.0128 10.6604 31.6488 10.4171 31.2436 10.417H19.9379ZM28.7319 0C29.0537 -3.11761e-08 29.3565 0.15468 29.5444 0.416016L31.3745 2.96191C31.8496 3.62344 31.3766 4.54492 30.562 4.54492H19.935C19.1544 4.54492 18.675 3.69079 19.0815 3.02441L20.6342 0.479492C20.8158 0.181846 21.1391 3.37707e-08 21.4877 0H28.7319Z" />
      </g>
    </g>
  ),
  ny_placering: (
    <g transform="scale(0.48)">
      <defs>
        <clipPath id="clip_ny_placering">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip_ny_placering)">
        <path d="M45.0001 0H5.00005C2.25005 0 5.46798e-05 2.25 5.46798e-05 5V45C5.46798e-05 47.75 2.25005 50 5.00005 50H45.0001C47.7501 50 50.0001 47.75 50.0001 45V5C50.0001 2.25 47.7501 0 45.0001 0ZM16 46H10H4V40V34.5H10H16V39.5V46ZM16 31H10H4V25V19.5H16V24.5V31ZM16 16H10H4V10V4H10H16V10V16ZM31 46H25.5H20.0001V34.5H25H31V39.5V46ZM31 31H25.5H20.0001V19.5H31V24.5V31ZM30.5 16H25H20.0001V4H25H30.5V10V16ZM46 46H40H35.0001V34.5H40H46V39.5V46ZM46 31H40.5H35.0001V19.5H40.5H46V25V31ZM46 16H40.5H35.0001V4H40H46V10V16Z" />
        <rect x="6" y="7" width="8" height="6" />
      </g>
    </g>
  ),
  avliden: (
    <g transform="scale(0.48)">
      <defs>
        <clipPath id="clip_avliden">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip_avliden)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.65114 39.8306L0.501674 38.1852C-0.0930088 37.3339 -0.164338 36.2266 0.316284 35.3073L6.00779 25.5098C6.49269 24.5823 7.45885 24 8.51291 24H21C21.9597 24 22.8535 24.4834 23.3727 25.2832L29.5513 35.2318C30.1683 36.1821 30.1474 37.4071 29.4983 38.3362L28.4544 39.8306L24.1499 47.3864C23.6863 48.3708 22.6894 49 21.5932 49H8.25851C7.16233 49 6.16537 48.3708 5.70181 47.3864L1.65114 39.8306ZM27.7585 37.1425L27.3457 37.7336H2.75985L2.24147 36.9915C2.0928 36.7787 2.07497 36.5019 2.19512 36.272L7.88663 26.4745C8.00785 26.2426 8.24939 26.097 8.51291 26.097H21C21.2399 26.097 21.4634 26.2179 21.5932 26.4178L27.7718 36.3664C27.926 36.604 27.9208 36.9103 27.7585 37.1425ZM26.1193 39.8306H3.98626L7.61933 46.4995C7.73522 46.7457 7.98446 46.903 8.25851 46.903H21.5932C21.8672 46.903 22.1165 46.7457 22.2324 46.4995L26.1193 39.8306Z"
        />
        <path d="M46.6519 47C47.1033 47 47.4985 47.3026 47.6167 47.7383L48.0181 49.2139C48.1255 49.6098 47.8267 50 47.4165 50H35.6519C35.2718 49.9998 34.9925 49.6422 35.0845 49.2734L35.4634 47.7578C35.5745 47.3126 35.9742 47.0001 36.4331 47H46.6519ZM46.0581 21.499C46.4497 21.499 46.8053 21.7274 46.9604 22.0869C47.5261 23.3986 48.8552 26.6379 49.2798 29.042C50.2349 34.4504 47.8205 42.4834 47.0532 44.832C46.9218 45.2341 46.5456 45.499 46.1226 45.499H36.8442C36.4399 45.4989 36.0776 45.2595 35.9331 44.8818C35.061 42.6019 32.1957 34.508 33.2173 29.042C33.6753 26.5916 35.1647 23.3299 35.7798 22.0488C35.9427 21.7096 36.2863 21.4992 36.6626 21.499H46.0581ZM38.1626 23.875C37.7788 23.875 37.4289 24.0931 37.272 24.4434C36.8405 25.4065 35.9968 27.413 35.6694 29.042C34.7368 33.6839 36.6483 40.4403 37.3159 42.5762C37.4431 42.983 37.8203 43.249 38.2466 43.249H44.5649C45.0126 43.249 45.4041 42.9563 45.5142 42.5225C46.0696 40.3321 47.5913 33.6631 46.8286 29.042C46.5696 27.4729 45.913 25.5133 45.5581 24.5186C45.4191 24.129 45.0488 23.875 44.6353 23.875H38.1626ZM43.1382 17C43.4707 17 43.7824 17.1656 43.9683 17.4414L44.6421 18.4414C45.0892 19.1055 44.6136 19.9997 43.813 20H38.5239C37.7596 20 37.2803 19.1742 37.6597 18.5107L38.2358 17.5039C38.4139 17.1925 38.7453 17 39.104 17H43.1382Z" />
      </g>
    </g>
  ),
  /**
   * Delsystem
   */
  delsystem_anlaggning: (
    <g>
      <polygon points="6 1 6 2 5 2 5 3 6 3 6 4.5 4 9 9 9 7 4.5 7 3 8 3 8 2 7 2 7 1" />
      <path d="M9,15 L9,14 L17.5,14 L18.5,15 L9,15 Z M18,19 L16,19 L16,17 C16,16.492 16.3205,16 17,16 C17.6795,16 18,16.5 18,17 L18,19 Z M15,19 L13,19 L13,17 C13,16.492 13.3205,16 14,16 C14.6795,16 15,16.5 15,17 L15,19 Z M12,19 L10,19 L10,17 C10,16.492 10.3205,16 11,16 C11.6795,16 12,16.5 12,17 L12,19 Z M6.5,13.6935 C5.6715,13.6935 5,13.022 5,12.194 C5,11.3645 5.6715,10.6935 6.5,10.6935 C7.3285,10.6935 8,11.3645 8,12.194 C8,13.022 7.3285,13.6935 6.5,13.6935 Z M18,13 L9,13 L9,10 L4,10 L4,21 L5.5,21 L5.5,18.393 C5.5,17.9005 5.9905,17.518 6.5,17.518 C7.0095,17.518 7.5,17.9005 7.5,18.393 L7.5,21 L20,21 L20,15 L18,13 Z" />
    </g>
  ),
  delsystem_bokning: (
    <g fillRule="evenodd" transform="translate(2.000000, 2.000000)">
      <path d="M18,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L18,0 C19.1045695,-2.02906125e-16 20,0.8954305 20,2 L20,18 C20,19.1045695 19.1045695,20 18,20 Z M15.5,2 C14.671625,2 14,2.671625 14,3.5 C14,4.328375 14.671625,5 15.5,5 C16.328375,5 17,4.328375 17,3.5 C17,2.671625 16.328375,2 15.5,2 Z M4.5,2 C3.671625,2 3,2.671625 3,3.5 C3,4.328375 3.671625,5 4.5,5 C5.328375,5 6,4.328375 6,3.5 C6,2.671625 5.328375,2 4.5,2 Z M18,6.51691034 C18,6.20855172 17.7415187,6 17.4228021,6 L2.57719786,6 C2.25848128,6 2,6.20855172 2,6.51691034 L2,17.400331 C2,17.7086069 2.25848128,18 2.57719786,18 L15,18 L15,16.9908257 C15,15.8898455 15.8898361,14.9959088 16.9908047,14.9908469 L18,14.9862069 L18,6.51691034 Z" />
      <g transform="translate(5.000000, 8.000000)">
        <path d="M5,8 L0.142512861,8 L0.142512861,7.27921928 L2.70878713,4.24402202 C3.08882143,3.78508549 3.35113779,3.41199143 3.49538861,3.1246165 C3.63963943,2.83748824 3.71182277,2.54012303 3.71182277,2.2330142 C3.71182277,1.82106902 3.59468415,1.48337265 3.36052278,1.21955506 C3.12624554,0.955860814 2.81387589,0.823767017 2.42364555,0.823767017 C1.95520693,0.823767017 1.59116189,0.965727765 1.33139454,1.24927925 C1.07174306,1.53295407 0.941975251,1.92787876 0.941975251,2.4336833 L0,2.4336833 C0,1.70735242 0.219678361,1.12014554 0.659382676,0.672062655 C1.09897113,0.223979773 1.68698151,0 2.42364555,0 C3.11268944,0 3.6574825,0.192405532 4.05802475,0.577093258 C4.45856699,0.962027658 4.65889605,1.47424572 4.65889605,2.11374744 C4.65889605,2.89064644 4.19381749,3.81567303 3.26377624,4.88882722 L1.27798118,7.18165981 L5,7.18165981 L5,8 Z" />
        <polygon points="10 0.571392848 6.93596503 8 5.95023357 8 9.00409324 0.835083771 5 0.835083771 5 0 10 0" />
      </g>
    </g>
  ),
  delsystem_diarium: (
    <g transform="translate(2.000000, 2.000000)" fillRule="evenodd">
      <path d="M18,7 L17,7 L17,16 C17,16.5522847 16.5522847,17 16,17 L4,17 L4,17 C4,18.1045695 4.8954305,19 6,19 L18,19 C19.1045695,19 20,18.1045695 20,17 L20,9 C20,7.8954305 19.1045695,7 18,7 Z" />
      <path d="M15.2119373,5.39968802 C15.7085218,5.77796458 16,6.36641404 16,6.99066508 L16,14 C16,15.1045695 15.1045695,16 14,16 L2,16 C0.8954305,16 -2.53721539e-14,15.1045695 0,14 L2.12718732e-13,6.99066508 C2.27057887e-13,6.36641404 0.291478163,5.77796458 0.78806271,5.39968802 L6.78806271,0.82914837 C7.50399207,0.28378445 8.49600793,0.28378445 9.21193729,0.82914837 L15.2119373,5.39968802 Z M9.2803688,3.066974 C8.53867689,2.44889741 7.46132311,2.44889741 6.7196312,3.066974 L2,7 L6.7196312,10.933026 C7.46132311,11.5511026 8.53867689,11.5511026 9.2803688,10.933026 L14,7 L9.2803688,3.066974 Z" />
    </g>
  ),
  delsystem_ekonomi: (
    <g fillRule="evenodd">
      <polygon points="8 16 10 16 10 9.5 8 11" />
      <polygon points="12 16 14 16 14 9.5 12 8" />
      <polygon points="16 11.5 16 16 18 16 18 9.5" />
      <polygon points="20.5 4 18 4.5 18.776 5.224 16 8 12 4.75 8 8 8 9.25 12 6 16 9.25 19.422 5.827 20.143 6.5" />
      <polygon points="22 18 6 18 6 2 4 2 4 18 2 18 2 20 4 20 4 22 6 22 6 20 22 20" />
    </g>
  ),
  delsystem_grav: (
    <g fillRule="evenodd" transform="translate(3.000000, 1.000000)">
      <path d="M14,18 L18,18 L18,22 L1.53918545e-13,22 L1.53918545e-13,18 L4,18 L4,9 C4,8.06064238 5.85519392,6 8,6 L8,4 L6,4 L6,2 L8,2 L8,0.00355222138 L10,0.00355222138 L10,2 L12,2 L12,4 L10,4 L10,6 C12.2348061,5.99323712 14,8.06064238 14,9 L14,18 Z M7,16 L11,16 L11,12 L7,12 L7,16 Z M9,10 C9.55229412,10 10,9.55229412 10,9 C10,8.44770588 9.55229412,8 9,8 C8.44770588,8 8,8.44770588 8,9 C8,9.55229412 8.44770588,10 9,10 Z" />
    </g>
  ),
  delsystem_kremation: (
    <g transform="translate(6.000000, 1.000000)" fillRule="evenodd">
      <polygon points="10 20 2 20 0 22 12 22" />
      <path d="M11,4 C11,3 9,2 8,2 L4,2 C3,2 1,3 1,4 C1,4.00281285 11,4.00281285 11,4 Z" />
      <path d="M7,2 L7,1 C7,0.333333333 6.66735614,0 6.00206842,0 C5.33678071,8.14742474e-17 5.0027579,0.333333333 5,1 L5,2 L7,2 Z" />
      <path d="M12,8 C12,10 12,11 12,11 C12,12 11.3076111,14.1134839 11,15 C10.492286,16.4636129 10,19 10,19 L2,19 C1.67185354,17.3090753 1.33852021,15.9757419 1,15 C0.692521489,14.1134839 -2.34534614e-14,12 0,11 C0,11 9.02056208e-15,8.47497114 0,8 C-1.91235916e-14,7 1,5 2,5 L10,5 C11,5 12,7 12,8 Z M3,16 L3,17 L9,17 L9,16 L3,16 Z M2,14 L2,15 L10,15 L10,14 L2,14 Z M8,8 L7,8 L7,7 L5,7 L5,8 L4,8 L4,10 L5,10 L5,12 L7,12 L7,10 L8,10 L8,8 Z" />
    </g>
  ),
  delsystem_bisattning: (
    <g transform="translate(5 1)">
      <path d="M11.2,22H2.8L0,7.861,2.8,0h8.4L14,7.861,11.2,22ZM3.5,1,1,7.977,3.5,21h7L13,7.977,10.5,1ZM9.75,20.25H4.25L2,7.96,4.25,1.75h5.5L12,7.96,9.75,20.249Z" />
    </g>
  ),
  delsystem_bisattning_bird: (
    <g transform="translate(5 1)">
      <path d="M11.2,22H2.8L0,7.861,2.8,0h8.4L14,7.861,11.2,22ZM2,4.221l.177.464L1,7.977,3.5,21h7L13,7.977,10.5,1h-7L2.3,4.345,2,4.221ZM9.75,20.25H4.25L2,7.96l.7-1.936.76,1.19,2.115.731L3.756,7.8,4.993,9.314l1.761-.29-.4,1.061L3.085,12.316l2.178.9,1.326-2.028H6.6a4.2,4.2,0,0,0,2.753-1.108,4.165,4.165,0,0,0,.975-3.026l.673-.5A2.907,2.907,0,0,0,9.47,5.69H9.429C8.7,5.689,8.014,6.7,8.007,6.71l-4.829-2L4.25,1.75h5.5L12,7.96,9.75,20.249ZM5.564,6.8l-2.84-.842L2.9,5.475,5.565,6.8Z" />
    </g>
  ),
  delsystem_leverantor: (
    <g fillRule="evenodd">
      <path d="M18.5 15C18.5 15.552 18.052 16 17.5 16H14.5C13.948 16 13.5 15.552 13.5 15V13C13.5 12.448 13.948 12 14.5 12H17.5C18.052 12 18.5 12.448 18.5 13V15ZM19 10C19 8.89551 19 8.50001 18.5 8.00001C18.5 8.00001 17 9.50001 16.5 10C16 10.5 14.5 11.1797 14.5 10.5V8.50001H14C14 8.50001 11.5 8.50001 9.5 11C7.5 13.5 8.78811 14.3294 7 14.5C5.21188 14.6706 5.69468 8.57007 6.99999 8.00001C5.04677 7.97472 3.9907 8.2388 4 10V18C4 19.1045 4.8955 20 6 20H17C18.1045 20 19 19.1045 19 18C19.552 18 20 17.552 20 17V11C20 10.448 19.552 10 19 10Z" />
      <path d="M16 14C16 14.551 15.553 15 15.0015 15C14.448 15 14 14.551 14 14C14 13.448 14.448 13 15.0015 13C15.553 13 16 13.448 16 14Z" />
      <path d="M20 5.24592L15.4782 1V3.35885C7.75685 3.35885 6.81189 10.8732 7.02636 13.3839C7.35064 12.1172 7.5553 7.133 15.4782 7.133V9.49184L20 5.24592Z" />
    </g>
  ),
  delsystem_kund: (
    <g fillRule="evenodd">
      <path d="M18.5 15C18.5 15.552 18.052 16 17.5 16H14.5C13.948 16 13.5 15.552 13.5 15V13C13.5 12.448 13.948 12 14.5 12H17.5C18.052 12 18.5 12.448 18.5 13V15ZM19 10C19 8.8955 18.1045 8 17 8H12C12 8.5 12 8.5 12 9H12.5C12.5 9 13.2969 9 14 9C15.2195 9 14.5 10 14.5 10C14.5 10 9.69529 16.3035 9.5 16.5C9.30471 16.6965 9.19533 16.7326 9 16.5L4.00001 10L4 14V18C4 19.1045 4.8955 20 6 20H17C18.1045 20 19 19.1045 19 18C19.552 18 20 17.552 20 17V11C20 10.448 19.552 10 19 10Z" />
      <path d="M16 14C16 14.551 15.553 15 15.0015 15C14.448 15 14 14.551 14 14C14 13.448 14.448 13 15.0015 13C15.553 13 16 13.448 16 14Z" />
      <path d="M9.22857 15L13 10.1303H10.9048C10.9048 1.81506 4.23017 0.797424 2 1.02838C3.12514 1.37761 7.55238 1.59802 7.55238 10.1303H5.45714L9.22857 15Z" />
      <path d="M6.38751 8V9H4C4.5 8 5.5 8 6.38751 8Z" />
    </g>
  ),
  delsystem_musik: (
    <g transform="translate(2.000000, 1.000000)" fillRule="evenodd">
      <path d="M20,0 L20,11 C20,12 19.5,12.5 19,13 C18.5,13.5 16.4,14 16,13.5 C15.6,13 15.8,12.3 16,12 C16.2,11.7 17.5,10.9 18,11 L18.0185005,5.5 L14,7.5 L14,15 C14,16 13.5,16.5 13,17 C12.5,17.5 10.4,18 10,17.5 C9.6,17 9.8,16.3 10,16 C10.2,15.7 11.5,14.9 12,15 L12,4 L20,0 Z M14,6.5 L18,4 L18,3 L14,5.5 L14,6.5 Z" />

      <g transform="translate(0.000000, 2.000000)">
        <path d="M3.4,12 C3.4,11.5 3.7,10.5 4.6,10.5 C5.9,10.5 6.5,11.4 6.5,12.5 C6.5,13.6 6.0021037,14.5 4.5,14.5 C2.69785231,14.5 1.5,13.5 1.5,12 C1.5,10.5 3.95897316,8.95531851 5.5,7.5 C7.04102684,6.04475641 8.5,5 8.5,3 C8.5,2 7.77348798,0 6.5,0 C5.71641306,0 4,2 4,3 L4,6.01829443 L5.5,4.5 L5.5,4 C5.5,3 6,2 6.5,2 C7,2 7,2.5 7,3 C7,4 6.145375,4.9515853 5,6.01829443 C3.93239183,7.01255605 1.00737075e-16,9 0,12 C0,15 1.70000005,16 4.5,16 C6.19999981,16 8.5,14.5 8.5,12.5 C8.5,10.5 6.5,9.19999981 5,9.19999981 C3.5,9.19999981 2.49237791,10.5 2.49618896,12 C2.5,13.5 3.88040851,13.7535464 3.88040851,13.7535464 C3.88040851,13.7535464 3.4000001,13 3.4000001,12 Z" />
        <path d="M4,16 C5.33333333,16 6,16 6,16 L6,17.9875006 C6,19.5 4,20 3,20 C2,20 1,19 1,18 C1,17.5 1.5,17 2,17 C2.5,17 3,17.5 3,18 C3,18.3333333 2.83333333,18.6666667 2.5,19 C2.8283404,19 2.99500706,19 3,19 C3.5,19 4,18.5 4,17.9875006 C4,17.6075664 4,16.9450661 4,16 Z" />
        <polygon points="4 9 5.5 7.5 5.5 10 4 10" />
        <polygon points="4 11 5.5 11 5.5 14 4 14" />
      </g>
    </g>
  ),
  delsystem_musik_old: (
    <g transform="translate(2.000000, 1.000000)" fillRule="evenodd">
      <path d="M20,0 L20,11 C20,11.2 19.5,11.7 19,12 C18.5,12.3 17.3,12.4 17,12 C16.7,11.6 16.8,11.3 17,11 C17.2,10.7 18.5,9.9 19,10 L19.0185,4 L13,7 L13,15 C13,15.2 12.5,15.7 12,16 C11.5,16.3 10.3,16.4 10,16 C9.7,15.6 9.8,15.3 10,15 C10.2,14.7 11.5,13.9 12,14 L12,4 L20,0 Z M13,6 L19,3 L19,2 L13,5 L13,6 Z" />
      <g transform="translate(0.000000, 2.000000)">
        <path d="M3,12 C3,11.5 3.7,10.5 4.6,10.5 C5.9,10.5 6.5,11.4 6.5,12.5 C6.5,13.6 6.0021037,14.5 4.5,14.5 C2.69785231,14.5 1.5,13.5 1.5,12 C1.5,10.5 3.45897316,8.95531851 5,7.5 C6.54102684,6.04475641 8,5 8,3 C8,2 7.77348798,0.5 6.5,0.5 C5.71641306,0.5 4,2 4,3 L4,6.01829443 L5,5 L5,4 C5,3 6,2 6.5,2 C7,2 7,2.5 7,3 C7,4 6.145375,4.9515853 5,6.01829443 C3.93239183,7.01255605 4.55592933e-16,10 3.88578059e-16,11.9906819 C3.88578059e-16,14 1.70000005,15.5 4.5,15.5 C6.19999981,15.5 8,14.5 8,12.5 C8,10.5 6.5,9.5 5,9.5 C3.5,9.5 2.49237791,10.5 2.49618896,12 C2.5,13.5 3.88040851,13.7535464 3.88040851,13.7535464 C3.88040851,13.7535464 3,13 3,12 Z" />
        <path d="M4,16 C4.66666667,16 5,16 5,16 L5,17.9875006 C5,19 4,20 3,20 C2,20 1,19 1,18 C1,17.5 1.5,17 2,17 C2.5,17 3,17.5 3,18 C3,18.3333333 2.83333333,18.6666667 2.5,19 C2.8283404,19 2.99500706,19 3,19 C3.5,19 4,18.5 4,17.9875006 C4,17.6075664 4,16.9450661 4,16 Z" />
        <polygon points="4 9 5 8 5 10 4 10" />
        <polygon points="4 11 5 11 5 14 4 14" />
      </g>
    </g>
  ),
  delsystem_order: (
    <g fillRule="evenodd">
      <path d="M13.5,3 L5.5,3 C4.6565,3 4,3.6565 4,4.5 L4,16.5 L5.5,16.5 L5.5,4.5 L13.5,4.5 L13.5,3 Z" />
      <path d="M17.825,20 L9.5,20 L9.5,9.5 L14,9.5 L14,13.5 L17.288,13.5 L18.858,12 L14.825,8 L9.4035,8 C8.5605,8 8,8.4465 8,9.2895 L8,19.9735 C8,20.817 8.5605,21.5 9.4035,21.5 L17.7985,21.5 C18.6415,21.5 19.5,20.817 19.5,19.9735 L19.5,18.4985 L17.825,20 Z" />
      <path d="M22.8705,12.796375 C23.043,12.622875 23.043,12.342375 22.8705,12.169375 L21.8305,11.129375 C21.657,10.956875 21.377,10.956875 21.2035,11.129375 L20.3895,11.942875 L22.057,13.609375 L22.8705,12.796375 Z M19.915,12.418375 L21.581,14.084375 L16.666,18.998875 L15,18.998875 L15,17.332875 L19.915,12.418375 Z" />
    </g>
  ),

  // FIXME: De här ligger fel
  kontoplan_select: (
    <g
      id="term-type-select"
      transform="translate(1.000000, 3.000000)"
      fillRule="evenodd"
    >
      <path d="M7,0 L7,2 L21,2 L21,0 L7,0 Z M15,4 L15,6 L21,6 L21,4 L15,4 Z M15,8 L15,10 L21,10 L21,8 L15,8 Z M11,16.17 L16,21 L21,16.17 L11,16.17 Z" />
      <path
        d="M9.57721102,8.45326168 L9.03247374,8.45326168 L8.84311922,8.64124407 C9.51203465,9.42130238 9.91887245,10.4325653 9.91887245,11.5405637 C9.91887245,14.0035447 7.92241715,16 5.45943622,16 C2.99645529,16 1,14.0035447 1,11.5405637 C1,9.07758276 2.99645529,7.08112744 5.45943622,7.08112744 C6.56743461,7.08112744 7.57801146,7.48727917 8.35806977,8.15550855 L8.54742429,7.96752616 L8.54742429,7.424161 L11.9763877,4 L12.9993138,5.02292608 L9.57721102,8.45326168 L9.57721102,8.45326168 Z M5.45943622,8.45326168 C3.75387338,8.45326168 2.37213422,9.83500086 2.37213422,11.5405637 C2.37213422,13.2454405 3.75387338,14.6278658 5.45943622,14.6278658 C7.16431299,14.6278658 8.54673822,13.2454405 8.54673822,11.5405637 C8.54673822,9.83500086 7.16431299,8.45326168 5.45943622,8.45326168 L5.45943622,8.45326168 Z"
        transform="translate(6.999657, 10.000000) scale(-1, -1) translate(-6.999657, -10.000000) "
      />
    </g>
  ),
  pin: (
    <g>
      <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
    </g>
  ),
  pinOff: (
    <g>
      <path d="M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z" />
    </g>
  ),
  timer_outlined: (
    <path d="M12 22.5C9.61305 22.5 7.32387 21.5518 5.63604 19.864C3.94821 18.1761 3 15.8869 3 13.5C3 11.1131 3.94821 8.82387 5.63604 7.13604C7.32387 5.44821 9.61305 4.5 12 4.5C14.045 4.49581 16.0292 5.19489 17.62 6.48L19.04 5.06C19.5515 5.4866 20.0234 5.95851 20.45 6.47L19.03 7.89C20.0884 9.21329 20.7513 10.8087 20.9425 12.4923C21.1337 14.176 20.8453 15.8794 20.1106 17.4063C19.3759 18.9332 18.2248 20.2215 16.7898 21.1227C15.3548 22.0239 13.6945 22.5013 12 22.5V22.5ZM12 6.5C10.3821 6.50139 8.81477 7.06362 7.56493 8.09094C6.31508 9.11826 5.46004 10.5471 5.14547 12.1341C4.83089 13.7211 5.07624 15.3681 5.83972 16.7945C6.60319 18.2209 7.83757 19.3385 9.33259 19.9569C10.8276 20.5753 12.4908 20.6563 14.0388 20.1861C15.5868 19.7158 16.924 18.7234 17.8224 17.378C18.7209 16.0325 19.1251 14.4172 18.9662 12.8071C18.8073 11.1971 18.0951 9.69189 16.951 8.548C16.3021 7.89629 15.5304 7.37972 14.6806 7.02819C13.8308 6.67665 12.9197 6.49713 12 6.5V6.5ZM13 14.5H11V8.5H13V14.5ZM15 3.5H9V1.5H15V3.5Z" />
  ),
  save_as: (
    <path d="M19,12 L19,19 L5,19 L5,12 L3,12 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 Z M13,9.67 L15.59,7.09 L17,8.5 L12,13.5 L7,8.5 L8.41,7.09 L11,9.67 L11,3 L13,3 L13,9.67 Z M7,15 L9,15 L9,17 L7,17 L7,15 Z M11,15 L13,15 L13,17 L11,17 L11,15 Z M15,15 L17,15 L17,17 L15,17 L15,15 Z" />
  ),
  sigma: (
    <g>
      <path d="M5,4H18V9H17L16,6H10.06L13.65,11.13L9.54,17H16L17,15H18V20H5L10.6,12L5,4Z" />
    </g>
  ),
  swap_u: (
    <g transform="translate(4.000000, 5.000000)">
      <path d="M8.5,8 L4.5,15 L0.5,8 L3,8 C3,6.66666667 3,6 3,6 C3,2.42857143 5.61111111,3.91063684e-16 8.5,0 C11.3888889,0 14,2.42857143 14,6 C14,7.9047619 14,10.2380952 14,13 L11,13 C11,8.85714286 11,6.52380952 11,6 C11,3.85714286 9.58333333,3 8.5,3 C7.41666667,3 6,3.85714286 6,6 C6,6 6,6.66666667 6,8 L8.5,8 Z" />
    </g>
  ),
  reverse: (
    <path d="M11,5 L17,5 L7,15 L7,13 L13,7 L11,5 Z M12,18.96448 L6,18.96448 L16,9 L16,11 L10,17 L12,18.96448 Z" />
  ),
  resources_filter: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.2381 1C5.23646 1 2 4.06044 2 7.84444C2 12.9778 9.2381 23 9.2381 23C9.2381 23 10.1943 21.6759 11.4117 19.7438C11.2371 19.1801 11.1431 18.5804 11.1431 17.9583C11.1431 15.2362 12.9448 12.9405 15.4059 12.2284C16.0506 10.6214 16.4762 9.08917 16.4762 7.84444C16.4762 4.06044 13.2397 1 9.2381 1ZM14.6667 8.33333C14.6667 11.3709 12.2362 13.8333 9.2381 13.8333C6.23998 13.8333 3.80952 11.3709 3.80952 8.33333C3.80952 5.29577 6.23998 2.83333 9.2381 2.83333C12.2362 2.83333 14.6667 5.29577 14.6667 8.33333ZM9.23821 10.1667C10.4422 10.1667 11.4632 9.63722 11.8184 8.90415C12.4749 9.41183 12.8571 10.156 12.8571 11.0834C12.3014 12.3275 10.8907 12.9167 9.2381 12.9167C7.58549 12.9167 6.17473 12.3275 5.61905 11.0834C5.61905 10.1559 6.00134 9.41169 6.65797 8.90401C7.01312 9.63716 8.0341 10.1667 9.23821 10.1667ZM11.9525 6.5C11.9525 8.01878 10.7373 9.25 9.23821 9.25C7.73915 9.25 6.52393 8.01878 6.52393 6.5C6.52393 4.98122 7.73915 3.75 9.23821 3.75C10.7373 3.75 11.9525 4.98122 11.9525 6.5ZM19.6771 15.6062C19.9637 15.8225 20.0206 16.2301 19.8043 16.5166L16.6907 20.6416C16.5746 20.7953 16.3964 20.8897 16.204 20.8992C16.0116 20.9087 15.8249 20.8324 15.6942 20.6909L14.2841 19.1631C14.0406 18.8993 14.0571 18.4881 14.3209 18.2446C14.5846 18.0011 14.9959 18.0176 15.2394 18.2814L16.1218 19.2374L18.7667 15.7334C18.983 15.4469 19.3906 15.3899 19.6771 15.6062ZM21.905 17.9583C21.905 20.7091 19.7074 22.9167 17.024 22.9167C14.3406 22.9167 12.1431 20.7091 12.1431 17.9583C12.1431 15.2076 14.3406 13 17.024 13C19.7074 13 21.905 15.2076 21.905 17.9583Z"
      />
    </g>
  ),
  urval_info: (
    <g transform="translate(2.000000, 2.000000)">
      <path d="M10,0 C15.52,0 20,4.48 20,10 C20,15.52 15.52,20 10,20 C4.48,20 0,15.52 0,10 C0,4.48 4.48,0 10,0 Z M9,16 L11,16 L11,14 L9,14 L9,16 Z M4,6 L4,8 L16,8 L16,6 L4,6 Z M6,12 L14,12 L14,10 L6,10 L6,12 Z" />
    </g>
  ),
  sort: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z" />
      </svg>
    </g>
  ),
  sort_ascending: (
    <path d="M7,17h3l-4,4l-4-4h3V3h2 M12,17h4v2h-4 M22,5v2H12V5 M12,11h7v2h-7V11z" />
  ),
  sort_descending: (
    <path d="M7,7h3L6,3L2,7h3v14h2 M12,5h4v2h-4 M22,17v2H12v-2 M12,11h7v2h-7V11z" />
  ),
  legend_active: (
    <g id="active">
      <g
        id="Rectangle_494"
        data-name="Rectangle 494"
        fill="#fff"
        stroke="rgba(0,0,0,0.54)"
        strokeWidth="1"
      >
        <rect width="24" height="24" rx="4" stroke="none" />
        <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="none" />
      </g>
      <rect
        id="Rectangle_485"
        data-name="Rectangle 485"
        width="4"
        height="4"
        transform="translate(3 4)"
        fill="#c7205d"
      />
      <rect
        id="Rectangle_486"
        data-name="Rectangle 486"
        width="4"
        height="4"
        transform="translate(3 10)"
        fill="#3776d1"
      />
      <rect
        id="Rectangle_487"
        data-name="Rectangle 487"
        width="4"
        height="4"
        transform="translate(3 16)"
        fill="#74ad12"
      />
      <rect
        id="Rectangle_488"
        data-name="Rectangle 488"
        width="12"
        height="1"
        transform="translate(9 4.5)"
        fill="rgba(0,0,0,0.54)"
      />
      <rect
        id="Rectangle_491"
        data-name="Rectangle 491"
        width="12"
        height="1"
        transform="translate(9 10.5)"
        fill="rgba(0,0,0,0.54)"
      />
      <rect
        id="Rectangle_493"
        data-name="Rectangle 493"
        width="12"
        height="1"
        transform="translate(9 16.5)"
        fill="rgba(0,0,0,0.54)"
      />
      <rect
        id="Rectangle_489"
        data-name="Rectangle 489"
        width="8"
        height="1"
        transform="translate(9 6.5)"
        fill="rgba(0,0,0,0.54)"
      />
      <rect
        id="Rectangle_490"
        data-name="Rectangle 490"
        width="8"
        height="1"
        transform="translate(9 12.5)"
        fill="rgba(0,0,0,0.54)"
      />
      <rect
        id="Rectangle_492"
        data-name="Rectangle 492"
        width="8"
        height="1"
        transform="translate(9 18.5)"
        fill="rgba(0,0,0,0.54)"
      />
    </g>
  ),
  legend_inactive: (
    <g id="default">
      <g
        id="Rectangle_494"
        data-name="Rectangle 494"
        fill="#455a64"
        stroke="rgba(255,255,255,0.7)"
        strokeWidth="1"
      >
        <rect width="24" height="24" rx="4" stroke="none" />
        <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="none" />
      </g>
      <g
        id="Rectangle_485"
        data-name="Rectangle 485"
        transform="translate(3 4)"
        fill="#c7205d"
        stroke="rgba(255,255,255,0.5)"
        strokeWidth="1"
      >
        <rect width="4" height="4" stroke="none" />
        <rect x="0.5" y="0.5" width="3" height="3" fill="none" />
      </g>
      <g
        id="Rectangle_486"
        data-name="Rectangle 486"
        transform="translate(3 10)"
        fill="#3776d1"
        stroke="rgba(255,255,255,0.5)"
        strokeWidth="1"
      >
        <rect width="4" height="4" stroke="none" />
        <rect x="0.5" y="0.5" width="3" height="3" fill="none" />
      </g>
      <g
        id="Rectangle_487"
        data-name="Rectangle 487"
        transform="translate(3 16)"
        fill="#74ad12"
        stroke="rgba(255,255,255,0.5)"
        strokeWidth="1"
      >
        <rect width="4" height="4" stroke="none" />
        <rect x="0.5" y="0.5" width="3" height="3" fill="none" />
      </g>
      <rect
        id="Rectangle_488"
        data-name="Rectangle 488"
        width="12"
        height="1"
        transform="translate(9 4.5)"
        fill="rgba(255,255,255,0.87)"
      />
      <rect
        id="Rectangle_491"
        data-name="Rectangle 491"
        width="12"
        height="1"
        transform="translate(9 10.5)"
        fill="rgba(255,255,255,0.87)"
      />
      <rect
        id="Rectangle_493"
        data-name="Rectangle 493"
        width="12"
        height="1"
        transform="translate(9 16.5)"
        fill="rgba(255,255,255,0.87)"
      />
      <rect
        id="Rectangle_489"
        data-name="Rectangle 489"
        width="8"
        height="1"
        transform="translate(9 6.5)"
        fill="rgba(255,255,255,0.87)"
      />
      <rect
        id="Rectangle_490"
        data-name="Rectangle 490"
        width="8"
        height="1"
        transform="translate(9 12.5)"
        fill="rgba(255,255,255,0.87)"
      />
      <rect
        id="Rectangle_492"
        data-name="Rectangle 492"
        width="8"
        height="1"
        transform="translate(9 18.5)"
        fill="rgba(255,255,255,0.87)"
      />
    </g>
  ),
  error: (
    <g>
      <circle
        cx="11"
        cy="11"
        r="11"
        transform="translate(1 1)"
        fill="#ff1744"
      />
      <path
        d="M13.293,2.107l-1.4-1.4L7,5.6,2.107.707l-1.4,1.4L5.6,7,.707,11.893l1.4,1.4L7,8.4l4.893,4.893,1.4-1.4L8.4,7Z"
        transform="translate(5 5)"
        fill="#fff"
      />
    </g>
  ),
  circle: (
    <g>
      <circle cx="11" cy="11" r="11" transform="translate(1 1)" />
    </g>
  ),
  record_periodical: (
    <g>
      <rect x="7" y="11" width="2" height="2" />
      <rect x="10" y="11" width="2" height="2" />
      <rect x="13" y="11" width="2" height="2" />
      <rect x="7" y="15" width="2" height="2" />
      <rect x="10" y="15" width="2" height="2" />
      <path
        d="M19,4h-1V2h-2v2H8V2H6v2H5C3.9,4,3,4.9,3,6l0,14c0,1.1,0.9,2,2,2h8.5c-0.5-0.6-0.9-1.3-1.2-2H5V9h14v3.1
    c0.7,0.1,1.4,0.4,2,0.7V6C21,4.9,20.1,4,19,4z"
      />
      <path
        d="M18,13c-2.8,0-5,2.2-5,5s2.2,5,5,5c2.8,0,5-2.2,5-5S20.8,13,18,13z M18,21.5c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5
    s3.5,1.6,3.5,3.5S19.9,21.5,18,21.5z"
      />
      <path d="M18.3,15.3h-0.8v3l2.6,1.6l0.4-0.6l-2.2-1.3V15.3z" />
    </g>
  ),
  konteringforslag_menu: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 16.078H2V22h9.6683c-.7314-.5695-1.3773-1.2437-1.9152-2H4v-3.922ZM20 5.33238c.7024.19109 1.3724.46074 2 .79893V2h-2v3.33238ZM6 13H1v-2h5v2Zm4-4.99998H1v-2h9v2Zm6-5H1v-2h15v2Zm4.4403 8.77848c.1038-.5879.0633-1.0016-.0522-1.2804-.1773-.428-.3879-.75992-.6483-1.02037-.2921-.29206-.6388-.52374-1.0204-.68181-.3816-.15806-.7906-.23942-1.2037-.23942-.413 0-.822.08136-1.2036.23942-.3816.15807-.7283.38975-1.0204.68181-.2921.29207-.5238.63877-.6818 1.02037-.1143.2759-.1543.6872-.0481 1.2744.1051.5807.3326 1.2204.621 1.8689.2674.6012.5623 1.1569.8225 1.6472l.0568.107c.0397.0749.0797.1506.119.2257H17V13h1v2.6213h.8465c.0377-.073.0762-.1464.1143-.2192l.0542-.1034c.2575-.4909.5496-1.0479.8139-1.6505.2845-.6483.5087-1.2883.6114-1.8697Zm-.6019 5.3428c0-.1633.2144-.572.5081-1.1319.8037-1.532 2.2015-4.1964 1.4274-6.06529-.2334-.56359-.5421-1.07568-.9734-1.50704-.4314-.43135-.9435-.77352-1.5071-1.00697-.5636-.23344-1.1676-.3536-1.7777-.3536-.61 0-1.214.12016-1.7776.3536-.5636.23345-1.0757.57562-1.5071 1.00697-.4313.43136-.7735.94345-1.0069 1.50704-.7736 1.86749.6396 4.52949 1.4532 6.06209.2982.5616.5158.9715.5158 1.1351h4.6453Zm-4.6453 1.9707h4.6453v-1h-4.6453v1Zm4.6453.9854c0 .616-.2447 1.2067-.6803 1.6423s-1.0263.6803-1.6424.6803c-.616 0-1.2067-.2447-1.6423-.6803s-.6803-1.0263-.6803-1.6423H19.8384Z"
      />
    </g>
  ),
  additionalinfo_filled: (
    <g>
      <path d="M19.2014 14H17.8V16.8H15V18.2H17.8V21H19.2014V18.2H22V16.8H19.2014V14Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9979 12.2064C19.9993 12.1378 20 12.069 20 12C20 6.47715 15.5228 2 10 2C4.47715 2 0 6.47715 0 12C0 17.5228 4.47715 22 10 22C11.5345 22 12.9883 21.6544 14.2877 21.0367C13.4841 20.0805 13 18.8468 13 17.5C13 14.4624 15.4624 12 18.5 12C19.0193 12 19.5217 12.072 19.9979 12.2064ZM9 11H11V17H9V11ZM11 9V7H9V9H11Z"
      />
    </g>
  ),
  additionalinfo_unfilled: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 7.58172 5.58172 4 10 4C14.4183 4 18 7.58172 18 12C18 12.0075 18 12.015 18 12.0224C18.1647 12.0076 18.3314 12 18.5 12C19.0193 12 19.5217 12.072 19.9979 12.2064C19.9993 12.1378 20 12.069 20 12C20 6.47715 15.5228 2 10 2C4.47715 2 0 6.47715 0 12C0 17.5228 4.47715 22 10 22C11.5345 22 12.9883 21.6544 14.2877 21.0367C13.8582 20.5256 13.5199 19.9352 13.2981 19.2907C12.2925 19.7463 11.1759 20 10 20C5.58172 20 2 16.4183 2 12Z"
      />
      <path d="M19.2014 14H17.8V16.8H15V18.2H17.8V21H19.2014V18.2H22V16.8H19.2014V14Z" />
      <rect x="9" y="11" width="2" height="6" />
      <rect x="9" y="7" width="2" height="2" />
    </g>
  ),
  deviating_time: (
    <g clipPath="url(#clip0_2269_579)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.42843 19.1C10.5031 19.1 11.5604 18.8687 12.5313 18.4271C12.7659 19.0255 13.0808 19.5831 13.4624 20.0866C12.767 20.4182 12.0304 20.6646 11.2678 20.8175C9.43889 21.184 7.54314 20.9959 5.82032 20.2769C4.0975 19.5578 2.62499 18.3402 1.58898 16.7779C0.552968 15.2156 0 13.3789 0 11.5C0 8.98044 0.993349 6.56408 2.76152 4.78248C4.5297 3.00089 6.92785 2 9.42843 2C11.2932 2 13.1161 2.55717 14.6666 3.60104C16.2171 4.64491 17.4255 6.12861 18.1392 7.86451C18.2855 8.22048 18.4097 8.58379 18.5115 8.95233C17.8652 8.99219 17.2429 9.12187 16.6569 9.32915C16.3001 8.12299 15.6504 7.02117 14.762 6.12599C13.7071 5.06311 12.3631 4.33928 10.8999 4.04603C9.43679 3.75278 7.9202 3.90329 6.54194 4.47852C5.16369 5.05374 3.98567 6.02785 3.15687 7.27766C2.32806 8.52748 1.88569 9.99686 1.88569 11.5C1.88569 13.5156 2.68036 15.4487 4.0949 16.874C5.50944 18.2993 7.42797 19.1 9.42843 19.1ZM8.48558 12.45L12.1561 14.669C12.238 14.1995 12.3667 13.7462 12.5373 13.3143L9.89985 11.7375V6.75H8.48558V12.45ZM16.7167 20.4534C15.8209 20.0083 15.0763 19.3056 14.5769 18.434C14.2453 17.8554 14.0301 17.2166 13.9435 16.5541C13.857 15.8916 13.9008 15.2184 14.0724 14.573C14.244 13.9276 14.5402 13.3226 14.9439 12.7925C15.3476 12.2624 15.8509 11.8176 16.4253 11.4835C17.2902 10.9803 18.2838 10.7468 19.2804 10.8127C20.2771 10.8785 21.232 11.2406 22.0243 11.8532C22.8167 12.4658 23.411 13.3015 23.732 14.2544C24.0531 15.2073 24.0864 16.2348 23.8279 17.2069C23.5694 18.1789 23.0307 19.0519 22.2798 19.7154C21.5289 20.379 20.5995 20.8032 19.6093 20.9346C18.6191 21.0659 17.6125 20.8985 16.7167 20.4534ZM19.64 16.0762L19.7265 12.9707L18.956 12.9489L18.9114 15.6187L16.6373 16.9417L17.016 17.6026L19.64 16.0762Z"
      />
    </g>
  ),
  public: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"></path>
      </svg>
    </g>
  ),

  add: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 11V5H13V11H19V13H13L13 19H11L11 13L5 13V11L11 11Z"
        />
      </svg>
    </g>
  ),
  arrow_back: (
    <g>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M20 11.2479H7.8L13.4 5.44958L12 4L4 12.2833L12 20.5666L13.4 19.117L7.8 13.3187H20V11.2479Z" />
      </svg>
    </g>
  ),
  arrow_drop_down: (
    <g>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M7 10L12 15L17 10H7Z" />
      </svg>
    </g>
  ),
  arrow_drop_up: (
    <g>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M17 14L12 9L7 14L17 14Z" />
      </svg>
    </g>
  ),
  arrow_forward: (
    <g>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M4 13L16.17 13L10.58 18.59L12 20L20 12L12 4L10.59 5.41L16.17 11L4 11L4 13Z" />
      </svg>
    </g>
  ),
  arrow_right_alt: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.01 11H4V13H16.01V16L20 12L16.01 8V11Z" />
      </svg>
    </g>
  ),
  assignment: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z" />
      </svg>
    </g>
  ),
  attach_file: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" />
      </svg>
    </g>
  ),
  bolt: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 21h-1l1-7H7.5c-.88 0-.33-.75-.31-.78C8.48 10.94 10.42 7.54 13.01 3h1l-1 7h3.51c.4 0 .62.19.4.66C12.97 17.55 11 21 11 21z" />
      </svg>
    </g>
  ),

  bookmark: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z" />
      </svg>
    </g>
  ),
  bookmark_border: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z" />
      </svg>
    </g>
  ),
  build: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" />
      </svg>
    </g>
  ),

  clear: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      </svg>
    </g>
  ),

  check: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
    </g>
  ),

  delete: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
      </svg>
    </g>
  ),

  developer_board: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z" />
      </svg>
    </g>
  ),

  drag_handle: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
      </svg>
    </g>
  ),

  email: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
      </svg>
    </g>
  ),

  event: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" />
      </svg>
    </g>
  ),
  event_available: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z" />
      </svg>
    </g>
  ),

  event_note: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z" />
      </svg>
    </g>
  ),

  exit_to_app: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
      </svg>
    </g>
  ),

  expand_less: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
      </svg>
    </g>
  ),

  expand_more: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
      </svg>
    </g>
  ),

  file_copy: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z" />
      </svg>
    </g>
  ),

  help_outline: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
      </svg>
    </g>
  ),
  help_filled: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z" />
      </svg>
    </g>
  ),
  insert_chart: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
      </svg>
    </g>
  ),

  keyboard_arrow_up: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
      </svg>
    </g>
  ),

  keyboard_arrow_down: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
      </svg>
    </g>
  ),

  keyboard_return: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z" />
      </svg>
    </g>
  ),

  language: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
      </svg>
    </g>
  ),

  lock: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
      </svg>
    </g>
  ),

  lock_open: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z" />
      </svg>
    </g>
  ),

  more_horiz: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
    </g>
  ),

  more_vert: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
    </g>
  ),

  notifications: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
      </svg>
    </g>
  ),
  overview: (
    <g>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M3 19C2.45 19 1.97917 18.8042 1.5875 18.4125C1.19583 18.0208 1 17.55 1 17V7C1 6.45 1.19583 5.97918 1.5875 5.5875C1.97917 5.19583 2.45 5 3 5H13C13.55 5 14.0208 5.19583 14.4125 5.5875C14.8042 5.97918 15 6.45 15 7V17C15 17.55 14.8042 18.0208 14.4125 18.4125C14.0208 18.8042 13.55 19 13 19H3ZM3 17H13V7H3V17ZM17 19V5H19V19H17ZM21 19V5H23V19H21Z" />
      </svg>
    </g>
  ),
  people: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
      </svg>
    </g>
  ),

  person: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
    </g>
  ),

  pie_chart: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z" />
      </svg>
    </g>
  ),

  print: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" />
      </svg>
    </g>
  ),

  refresh: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
      </svg>
    </g>
  ),
  remove: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 13H5V11H19V13Z" />
      </svg>
    </g>
  ),
  restore: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
      </svg>
    </g>
  ),

  search: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
      </svg>
    </g>
  ),

  settings: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
      </svg>
    </g>
  ),

  sms_failed: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z" />
      </svg>
    </g>
  ),

  start: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 5v14l11-7z" />
      </svg>
    </g>
  ),

  table_chart: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 10.02H15V21H10V10.02ZM17 21H20C21.1 21 22 20.1 22 19V10H17V21ZM20 3H5C3.9 3 3 3.9 3 5V8H22V5C22 3.9 21.1 3 20 3ZM3 19C3 20.1 3.9 21 5 21H8V10H3V19Z" />
      </svg>
    </g>
  ),

  timer: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
      </svg>
    </g>
  ),

  warning: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
    </g>
  ),

  info: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </svg>
    </g>
  ),

  zoom_in: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z" />
      </svg>
    </g>
  ),

  zoom_out: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z" />
      </svg>
    </g>
  ),

  fullscreen: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
      </svg>
    </g>
  ),

  save: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
      </svg>
    </g>
  ),

  save_alt: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />
      </svg>
    </g>
  ),

  chevron_left: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
      </svg>
    </g>
  ),
  chevron_right: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 6L8.59003 7.41L13.17 12L8.59003 16.59L10 18L16 12L10 6Z" />
      </svg>
    </g>
  ),

  edit: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
      </svg>
    </g>
  ),

  close: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      </svg>
    </g>
  ),

  clear_all: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z" />
      </svg>
    </g>
  ),

  folder_open: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z" />
      </svg>
    </g>
  ),

  star_border: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" />
      </svg>
    </g>
  ),

  filter_list: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
      </svg>
    </g>
  ),

  image_search: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18 13V20H4V6H9.02C9.07 5.29 9.24 4.62 9.5 4H4C2.9 4 2 4.9 2 6V20C2 21.1 2.9 22 4 22H18C19.1 22 20 21.1 20 20V15L18 13ZM16.5 18H5.5L8.25 14.47L10.21 16.83L12.96 13.29L16.5 18ZM19.3 8.89C19.74 8.19 20 7.38 20 6.5C20 4.01 17.99 2 15.5 2C13.01 2 11 4.01 11 6.5C11 8.99 13.01 11 15.49 11C16.37 11 17.19 10.74 17.88 10.3L21 13.42L22.42 12L19.3 8.89ZM15.5 9C14.12 9 13 7.88 13 6.5C13 5.12 14.12 4 15.5 4C16.88 4 18 5.12 18 6.5C18 7.88 16.88 9 15.5 9Z" />
      </svg>
    </g>
  ),

  fullscreen_exit: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
      </svg>
    </g>
  ),

  add_circle: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
      </svg>
    </g>
  ),

  note_add: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z" />
      </svg>
    </g>
  ),

  publish: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z" />
      </svg>
    </g>
  ),

  remove_circle: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" />
      </svg>
    </g>
  ),

  restore_backup: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z" />
      </svg>
    </g>
  ),

  star: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    </g>
  ),

  remove_circle_outlined: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4-9H8v2h8v-2z" />
      </svg>
    </g>
  ),

  add_circle_outlined: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4-9h-3V8h-2v3H8v2h3v3h2v-3h3v-2z" />
      </svg>
    </g>
  ),

  select_all: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z" />
      </svg>
    </g>
  ),

  visibility: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
      </svg>
    </g>
  ),

  visibility_off: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
      </svg>
    </g>
  ),

  explore: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z" />
      </svg>
    </g>
  ),

  explore_off: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.27 2.27L1 3.54L3.78 6.32C3.67 6.48 3.57 6.64 3.47 6.8C3.43 6.87 3.38 6.94 3.34 7.01C3.25 7.16 3.17 7.32 3.09 7.48C3.04 7.58 2.99 7.69 2.93 7.8C2.87 7.94 2.8 8.08 2.74 8.23C2.64 8.47 2.55 8.71 2.47 8.96L2.38 9.26C2.33 9.46 2.28 9.65 2.24 9.85C2.22 9.96 2.2 10.07 2.17 10.18C2.13 10.38 2.1 10.58 2.08 10.79C2.07 10.89 2.05 10.99 2.05 11.09C2.02 11.38 2 11.69 2 12C2 17.52 6.48 22 12 22C12.31 22 12.62 21.98 12.92 21.95L13.22 21.92C13.42 21.9 13.63 21.86 13.83 21.83C13.94 21.81 14.05 21.79 14.16 21.76C14.36 21.72 14.55 21.67 14.74 21.61C14.84 21.58 14.94 21.56 15.04 21.52C15.29 21.44 15.53 21.35 15.77 21.25C15.92 21.19 16.06 21.12 16.2 21.06C16.31 21.01 16.42 20.96 16.53 20.9C16.69 20.82 16.84 20.74 16.99 20.65C17.06 20.61 17.13 20.56 17.2 20.52C17.36 20.42 17.52 20.32 17.68 20.21L20.46 23L21.73 21.73L2.27 2.27ZM6 18L9 11.54L12.46 15L6 18ZM22 12C22 12.31 21.98 12.62 21.95 12.92L21.92 13.22C21.9 13.42 21.86 13.63 21.83 13.83C21.81 13.94 21.79 14.05 21.76 14.16C21.72 14.36 21.67 14.55 21.61 14.74C21.58 14.84 21.56 14.95 21.52 15.05C21.44 15.3 21.35 15.54 21.25 15.78C21.19 15.93 21.12 16.07 21.06 16.21C21.01 16.32 20.96 16.43 20.9 16.54C20.82 16.7 20.74 16.85 20.65 17C20.61 17.07 20.56 17.14 20.52 17.21C20.42 17.37 20.32 17.53 20.21 17.69L15 12.46L18 6L11.54 9L6.32 3.78C6.48 3.67 6.64 3.57 6.8 3.47C6.87 3.43 6.94 3.38 7.01 3.34C7.16 3.25 7.32 3.17 7.47 3.09C7.58 3.04 7.69 2.99 7.8 2.93C7.94 2.87 8.08 2.8 8.23 2.74C8.47 2.64 8.71 2.55 8.96 2.47L9.27 2.38C9.46 2.33 9.65 2.27 9.85 2.23C9.96 2.21 10.07 2.19 10.18 2.16C10.38 2.12 10.58 2.09 10.79 2.07C10.89 2.06 10.99 2.04 11.09 2.04C11.38 2.02 11.69 2 12 2C17.52 2 22 6.48 22 12Z" />
      </svg>
    </g>
  ),

  image: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
      </svg>
    </g>
  ),

  vertical_split: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z" />
      </svg>
    </g>
  ),

  menu: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
      </svg>
    </g>
  ),

  open_in_new: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
      </svg>
    </g>
  ),
  outlook: (
    <g>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M18 17.0714H9V16.0714H18C18.2652 16.0714 18.5196 15.9661 18.7071 15.7785C18.8946 15.591 19 15.3367 19 15.0714V7.07144C19 6.80623 18.8946 6.55187 18.7071 6.36433C18.5196 6.1768 18.2652 6.07144 18 6.07144H9V3.07144H18C18.5304 3.07144 19.0391 3.28216 19.4142 3.65723C19.7893 4.0323 20 4.54101 20 5.07144V15.0714C20 15.6019 19.7893 16.1106 19.4142 16.4857C19.0391 16.8607 18.5304 17.0714 18 17.0714Z" />
        <path d="M12 10.0714H10V12.0714H12V10.0714Z" />
        <path d="M12 13.0714H10V15.0714H12V13.0714Z" />
        <path d="M15 7.07144H13V9.07144H15V7.07144Z" />
        <path d="M18 7.07144H16V9.07144H18V7.07144Z" />
        <path d="M15 10.0714H13V12.0714H15V10.0714Z" />
        <path d="M15 13.0714H13V15.0714H15V13.0714Z" />
        <path d="M18 10.0714H16V12.0714H18V10.0714Z" />
        <path d="M9 20.0714L0 16.4354V3.70744L9 0.0714417V20.0714ZM4.515 5.86444C3.95768 5.85622 3.41131 6.01961 2.95 6.33244C2.47537 6.66743 2.10763 7.1324 1.891 7.67144C1.6303 8.31377 1.50272 9.00235 1.516 9.69544V10.0804C1.50667 10.7634 1.63736 11.441 1.9 12.0714C2.1203 12.6074 2.48997 13.0687 2.965 13.4004C3.4264 13.7104 3.9712 13.8726 4.527 13.8654C5.08732 13.8742 5.63668 13.7097 6.1 13.3944C6.57233 13.0596 6.93769 12.5953 7.152 12.0574C7.40827 11.4168 7.53341 10.7313 7.52 10.0414V9.69344C7.53216 9.00071 7.40321 8.31275 7.141 7.67144C6.9237 7.13251 6.55568 6.66762 6.081 6.33244C5.61927 6.01971 5.07262 5.85634 4.515 5.86444ZM4.525 12.5484C4.29258 12.5542 4.06307 12.4958 3.86162 12.3798C3.66018 12.2637 3.49458 12.0944 3.383 11.8904C3.08755 11.3203 2.94947 10.6817 2.983 10.0404V9.66144C2.94691 9.02254 3.08517 8.38584 3.383 7.81944C3.49723 7.62328 3.66213 7.46146 3.86042 7.35097C4.05871 7.24047 4.28308 7.18537 4.51 7.19144C4.73857 7.18515 4.96456 7.24098 5.16391 7.35298C5.36325 7.46498 5.52848 7.62896 5.642 7.82744C5.9413 8.40014 6.07955 9.04334 6.042 9.68844V10.0714C6.07654 10.7121 5.9384 11.3504 5.642 11.9194C5.52999 12.1155 5.36702 12.2775 5.17037 12.3885C4.97371 12.4994 4.75071 12.555 4.525 12.5494V12.5484Z" />
      </svg>
    </g>
  ),
  pause_circle_outline: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z" />
      </svg>
    </g>
  ),
  check_circle_outline: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        version="1.1"
        id="svg2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs id="defs2" />

        <path
          d="M 10.396484,1.8105469 C 8.0665932,2.1776127 5.9331224,3.332243 4.3515625,5.0820312 2.7700009,6.8318213 1.8355549,9.0707533 1.7050781,11.425781 c -0.1304887,2.354983 0.5511259,4.683869 1.9296875,6.597656 1.3785796,1.91391 3.3714205,3.297744 5.6464844,3.919922 2.275083,0.622309 4.694798,0.4458 6.855469,-0.5 a 1.1459496,1.1459496 0 0 0 0.002,0 c 2.160603,-0.945819 3.931373,-2.603599 5.017578,-4.697265 1.086202,-2.093661 1.422049,-4.497516 0.951172,-6.808594 l -2.246094,0.457031 c 0.366323,1.797923 0.104764,3.668136 -0.740234,5.296875 -0.844996,1.628734 -2.221547,2.916563 -3.902344,3.652344 -1.68093,0.735801 -3.562254,0.874716 -5.3320312,0.390625 C 8.1168427,19.250354 6.566581,18.174437 5.4941406,16.685547 4.4217023,15.196735 3.8926293,13.384751 3.9941406,11.552734 4.0956438,9.7206623 4.822376,7.9803705 6.0527344,6.6191406 7.2830945,5.2579088 8.9413974,4.3597729 10.753906,4.0742187 c 1.812518,-0.2855556 3.668415,0.057586 5.257813,0.9746094 L 17.15625,3.0644531 C 15.113248,1.8857168 12.726366,1.4434825 10.396484,1.8105469 Z"
          id="path1"
        />
        <g id="path2">
          <path d="M 8.5,10.5 12,13.8333" id="path3" />
          <path
            d="M 20.357422,3.8554688 11.980469,12.232422 9.2910156,9.6699219 7.7089844,11.330078 11.208984,14.662109 a 1.1459496,1.1459496 0 0 0 1.601563,-0.01953 l 9.166015,-9.1660155 z"
            id="path4"
          />
        </g>
      </svg>
    </g>
  ),
  list: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
      </svg>
    </g>
  ),

  subdirectory_arrow_right: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z" />
      </svg>
    </g>
  ),

  description: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
      </svg>
    </g>
  ),

  drafts: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z" />
      </svg>
    </g>
  ),

  download: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
      </svg>
    </g>
  ),

  group: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
      </svg>
    </g>
  ),

  room: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
      </svg>
    </g>
  ),

  post_add: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z" />
        <path d="M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zm0 3v2h8v-2h-8zm0 3h8v2H7z" />
      </svg>
    </g>
  ),

  notes: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z" />
      </svg>
    </g>
  ),

  link: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
      </svg>
    </g>
  ),

  scheduler: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
      </svg>
    </g>
  ),

  inventory: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z" />
      </svg>
    </g>
  ),

  cloud_upload: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
      </svg>
    </g>
  ),

  send: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
      </svg>
    </g>
  ),

  unfold_more_double: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" />
      </svg>
    </g>
  ),

  undo: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
      </svg>
    </g>
  ),

  horizontal_rule: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 11h16v2H4z" />
      </svg>
    </g>
  ),

  free_cancellation: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.21 20H5V10h14v4.38l2-2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h8.21l-2-2zm5.33 2.5L13 18.96l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66z" />
      </svg>
    </g>
  ),

  aspect_ratio: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z" />
      </svg>
    </g>
  ),

  content_copy: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
      </svg>
    </g>
  ),

  access_time: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
      </svg>
    </g>
  ),

  cached: (
    <g>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#0d9488"
      >
        <path d="M482-160q-134 0-228-93t-94-227v-7l-64 64-56-56 160-160 160 160-56 56-64-64v7q0 100 70.5 170T482-240q26 0 51-6t49-18l60 60q-38 22-78 33t-82 11Zm278-161L600-481l56-56 64 64v-7q0-100-70.5-170T478-720q-26 0-51 6t-49 18l-60-60q38-22 78-33t82-11q134 0 228 93t94 227v7l64-64 56 56-160 160Z" />
      </svg>
    </g>
  ),

  alert: (
    <g>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
      >
        <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
      </svg>
    </g>
  ),
  day: (
    <g>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z" />
      </svg>
    </g>
  ),
  week: (
    <g>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M21 4H3C2.45 4 2 4.45 2 5V19C2 19.55 2.45 20 3 20H21C21.55 20 22 19.55 22 19V5C22 4.45 21.55 4 21 4M8 18H4V6H8V18M14 18H10V6H14V18M20 18H16V6H20V18Z" />
      </svg>
    </g>
  ),
  month: (
    <g>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M7 11H9V13H7V11M21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5M5 7H19V5H5V7M19 19V9H5V19H19M15 13V11H17V13H15M11 13V11H13V13H11M7 15H9V17H7V15M15 17V15H17V17H15M11 17V15H13V17H11Z" />
      </svg>
    </g>
  ),
  workweek: (
    <g>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M20,6C20.58,6 21.05,6.2 21.42,6.59C21.8,7 22,7.45 22,8V19C22,19.55 21.8,20 21.42,20.41C21.05,20.8 20.58,21 20,21H4C3.42,21 2.95,20.8 2.58,20.41C2.2,20 2,19.55 2,19V8C2,7.45 2.2,7 2.58,6.59C2.95,6.2 3.42,6 4,6H8V4C8,3.42 8.2,2.95 8.58,2.58C8.95,2.2 9.42,2 10,2H14C14.58,2 15.05,2.2 15.42,2.58C15.8,2.95 16,3.42 16,4V6H20M4,8V19H20V8H4M14,6V4H10V6H14Z" />
      </svg>
    </g>
  ),
  listView: (
    <g>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M3 5V19H20V5H3M7 7V9H5V7H7M5 13V11H7V13H5M5 15H7V17H5V15M18 17H9V15H18V17M18 13H9V11H18V13M18 9H9V7H18V9Z" />
      </svg>
    </g>
  ),
  importFromFile: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.7436 11.8333C11.7436 11.3731 12.088 11 12.5128 11H17.1282C17.553 11 17.8974 11.3731 17.8974 11.8333C17.8974 12.2936 17.553 12.6667 17.1282 12.6667H12.5128C12.088 12.6667 11.7436 12.2936 11.7436 11.8333Z" />
        <path d="M11.7436 15.1667C11.7436 14.7064 12.088 14.3333 12.5128 14.3333H17.1282C17.553 14.3333 17.8974 14.7064 17.8974 15.1667C17.8974 15.6269 17.553 16 17.1282 16H12.5128C12.088 16 11.7436 15.6269 11.7436 15.1667Z" />
        <path d="M6.14189 7.11153C6.3858 7.1183 6.61738 7.21526 6.78758 7.38188L9.83746 10.2882C9.95223 10.372 10.0451 10.48 10.1089 10.6037C10.1727 10.7274 10.2056 10.8635 10.2051 11.0013C10.2047 11.1391 10.1708 11.275 10.1062 11.3983C10.0415 11.5216 9.94791 11.629 9.83257 11.7122L6.78758 14.6138C6.70104 14.6997 6.59738 14.7682 6.48268 14.8155C6.36798 14.8627 6.24454 14.8877 6.1196 14.8889C5.99465 14.8901 5.87071 14.8675 5.75502 14.8225C5.63934 14.7775 5.53424 14.711 5.44588 14.6268C5.35753 14.5426 5.28769 14.4424 5.24046 14.3322C5.19323 14.222 5.16956 14.1039 5.17083 13.9848C5.1721 13.8657 5.19828 13.7481 5.24786 13.6388C5.29743 13.5295 5.36939 13.4307 5.45952 13.3483L6.98691 11.8928H3.36618L2.82411 11.8928C2.36897 11.8928 2 11.4931 2 11C2 10.5045 2.37076 10.1029 2.82811 10.1029L3.36618 10.1029H6.98691L5.45952 8.64741C5.32403 8.52166 5.23153 8.35987 5.19413 8.1832C5.15673 8.00653 5.17617 7.82322 5.2499 7.65725C5.32364 7.49129 5.44824 7.3504 5.60739 7.25303C5.76655 7.15566 5.95284 7.10634 6.14189 7.11153Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.64103 3.25C7.64103 2.01625 8.55304 1 9.66026 1H15.4936C15.6721 1.00004 15.8433 1.07907 15.9695 1.21973L21.8028 7.71973C21.929 7.86036 22 8.0511 22 8.25V19.5417C22 20.3471 21.3973 21 20.6538 21H9.66026C8.55304 21 7.64103 19.9838 7.64103 18.75V16.5556H8.98718V18.75C8.98718 19.1733 9.28042 19.5 9.66026 19.5H20.6538V9H16.8397C15.7325 9 14.8205 7.98375 14.8205 6.75V2.5H9.66026C9.28042 2.5 8.98718 2.82675 8.98718 3.25V5.44444H7.64103V3.25ZM19.7021 7.5L16.1667 3.56055V6.75C16.1667 7.17325 16.4599 7.5 16.8397 7.5H19.7021Z"
        />
      </svg>
    </g>
  ),
  add_profile: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM6 10V7H4V10H1V12H4V15H6V12H9V10H6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14Z" />
      </svg>
    </g>
  ),
  assistant: (
    <g>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-1l1.88-4.12L18 11l-4.12-1.88L12 5l-1.88 4.12L6 11l4.12 1.88z" />
      </svg>
    </g>
  ),
  insights: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_696_98)">
          <path d="M21 8C19.55 8 18.74 9.44 19.07 10.51L15.52 14.07C15.22 13.98 14.78 13.98 14.48 14.07L11.93 11.52C12.27 10.45 11.46 9 10 9C8.55 9 7.73 10.44 8.07 11.52L3.51 16.07C2.44 15.74 1 16.55 1 18C1 19.1 1.9 20 3 20C4.45 20 5.26 18.56 4.93 17.49L9.48 12.93C9.78 13.02 10.22 13.02 10.52 12.93L13.07 15.48C12.73 16.55 13.54 18 15 18C16.45 18 17.27 16.56 16.93 15.48L20.49 11.93C21.56 12.26 23 11.45 23 10C23 8.9 22.1 8 21 8Z" />
          <path d="M15 9L15.94 6.93L18 6L15.94 5.07L15 3L14.08 5.07L12 6L14.08 6.93L15 9Z" />
          <path d="M3.5 11L4 9L6 8.5L4 8L3.5 6L3 8L1 8.5L3 9L3.5 11Z" />
        </g>
        <defs>
          <clipPath id="clip0_696_98">
            <rect width="24" height="24" />
          </clipPath>
        </defs>
      </svg>
    </g>
  ),
  tipsAndUpdates: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_696_109)">
          <path d="M7 20H11C11 21.1 10.1 22 9 22C7.9 22 7 21.1 7 20ZM5 19H13V17H5V19ZM16.5 9.5C16.5 13.32 13.84 15.36 12.73 16H5.27C4.16 15.36 1.5 13.32 1.5 9.5C1.5 5.36 4.86 2 9 2C13.14 2 16.5 5.36 16.5 9.5ZM14.5 9.5C14.5 6.47 12.03 4 9 4C5.97 4 3.5 6.47 3.5 9.5C3.5 11.97 4.99 13.39 5.85 14H12.15C13.01 13.39 14.5 11.97 14.5 9.5ZM21.37 7.37L20 8L21.37 8.63L22 10L22.63 8.63L24 8L22.63 7.37L22 6L21.37 7.37ZM19 6L19.94 3.94L22 3L19.94 2.06L19 0L18.06 2.06L16 3L18.06 3.94L19 6Z" />
        </g>
        <defs>
          <clipPath id="clip0_696_109">
            <rect width="24" height="24" />
          </clipPath>
        </defs>
      </svg>
    </g>
  ),
  tasks: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_696_112)">
          <path d="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z" />
        </g>
        <defs>
          <clipPath id="clip0_696_112">
            <rect width="24" height="24" />
          </clipPath>
        </defs>
      </svg>
    </g>
  ),
  bar_chart_with_axis: (
    <g>
      <svg
        height="24px"
        width="24px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 512 512"
      >
        <path
          d="M431.952,112.527h-74.678c-4.661,0-8.44,3.778-8.44,8.44V503.56c0,4.662,3.779,8.44,8.44,8.44h74.678
	c4.661,0,8.44-3.778,8.44-8.44V120.967C440.392,116.305,436.613,112.527,431.952,112.527z"
        />
        <path
          d="M431.952,112.527h-33.758V512h33.758c4.661,0,8.44-3.778,8.44-8.44V120.967
	C440.392,116.305,436.613,112.527,431.952,112.527z"
        />
        <path
          d="M295.897,196.441h-74.678c-4.661,0-8.44,3.778-8.44,8.44V503.56c0,4.662,3.779,8.44,8.44,8.44h74.678
	c4.661,0,8.44-3.778,8.44-8.44V204.881C304.336,200.22,300.557,196.441,295.897,196.441z"
        />
        <path
          d="M295.897,196.441h-33.758V512h33.758c4.661,0,8.44-3.778,8.44-8.44V204.881
	C304.336,200.22,300.557,196.441,295.897,196.441z"
        />
        <path
          d="M159.84,289.753H85.163c-4.661,0-8.44,3.778-8.44,8.44V503.56c0,4.662,3.779,8.44,8.44,8.44h74.678
	c4.661,0,8.44-3.778,8.44-8.44V298.192C168.279,293.531,164.501,289.753,159.84,289.753z"
        />
        <path
          d="M159.84,289.753h-33.758V512h33.758c4.661,0,8.44-3.778,8.44-8.44V298.192
	C168.279,293.531,164.501,289.753,159.84,289.753z"
        />
        <path
          d="M502.998,512H9.002c-4.661,0-8.44-3.778-8.44-8.44V8.44C0.563,3.778,4.341,0,9.002,0
	s8.44,3.778,8.44,8.44v486.681h485.556c4.661,0,8.44,3.778,8.44,8.44S507.659,512,502.998,512z"
        />
      </svg>
    </g>
  ),
  line_chart: (
    <g>
      <svg
        height="24px"
        width="24px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M23 8C23 9.1 22.1 10 21 10C20.82 10 20.65 9.98 20.49 9.93L16.93 13.48C16.98 13.64 17 13.82 17 14C17 15.1 16.1 16 15 16C13.9 16 13 15.1 13 14C13 13.82 13.02 13.64 13.07 13.48L10.52 10.93C10.36 10.98 10.18 11 10 11C9.82 11 9.64 10.98 9.48 10.93L4.93 15.49C4.98 15.65 5 15.82 5 16C5 17.1 4.1 18 3 18C1.9 18 1 17.1 1 16C1 14.9 1.9 14 3 14C3.18 14 3.35 14.02 3.51 14.07L8.07 9.52C8.02 9.36 8 9.18 8 9C8 7.9 8.9 7 10 7C11.1 7 12 7.9 12 9C12 9.18 11.98 9.36 11.93 9.52L14.48 12.07C14.64 12.02 14.82 12 15 12C15.18 12 15.36 12.02 15.52 12.07L19.07 8.51C19.02 8.35 19 8.18 19 8C19 6.9 19.9 6 21 6C22.1 6 23 6.9 23 8Z" />
      </svg>
    </g>
  ),
  check_circle_filled: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
      </svg>
    </g>
  ),
  replay_outlined: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 5V1L7 6L12 11V7C15.31 7 18 9.69 18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13H4C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13C20 8.58 16.42 5 12 5Z" />
      </svg>
    </g>
  ),
  turn_left_outlined: (
    <g>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 13L7 12L7 10L3 14L7 18L7 16L7 15L15 15C16.1 15 17 14.1 17 13L17 4L15 4L15 13L7 13Z" />
      </svg>
    </g>
  ),
};

export type IconType = keyof typeof iconDefs;

const iconDef = (iconName: IconType): null | JSX.Element => iconDefs[iconName]; // Får man fel här beror det troligtvis på att något av objekten i iconDefs ovan inte matchar typen IconDef, dvs inte består av antingen <g></g> eller string

export default iconDef;
